// --- Non-Rug Category Guard ---
// Halts execution if product does not contain rug or related keywords in title/type/description
(function(w) {
  w.isRugProduct = function(p, productType, productDescription, productTags) {
    let title = '', type = '', desc = '', tags = '';
    if (p && typeof p === 'object') {
      title = String(p.title || p.name || '').toLowerCase();
      type = String(p.product_type || p.type || p.category || (Array.isArray(p.categories) ? p.categories.join(' ') : '') || '').toLowerCase();
      desc = String(p.description || '').toLowerCase();
      tags = Array.isArray(p.tags) ? p.tags.join(' ').toLowerCase() : String(p.tags || '').toLowerCase();
    } else {
      title = String(p || '').toLowerCase();
      type = String(productType || '').toLowerCase();
      desc = String(productDescription || '').toLowerCase();
      tags = Array.isArray(productTags) ? productTags.join(' ').toLowerCase() : String(productTags || '').toLowerCase();
    }

    const isRug = title.includes('rug') || type.includes('rug') || tags.includes('rug') || desc.includes('rug') ||
                  title.includes('carpet') || type.includes('carpet') || tags.includes('carpet') || desc.includes('carpet') ||
                  title.includes('runner') || type.includes('runner') || tags.includes('runner') || desc.includes('runner');

    const isExempt = title.includes('pad') || type.includes('pad') || tags.includes('pad') ||
                    title.includes('underlay') || type.includes('underlay') || tags.includes('underlay') ||
                    title.includes('cleaner') || type.includes('cleaner') || tags.includes('cleaner') ||
                    type.includes('furniture') || tags.includes('furniture') ||
                    type.includes('accessory') || tags.includes('accessory');

    return isRug && !isExempt;
  };

  w.checkRugCategoryGuard = function(productTitle, productType, productDescription) {
    const title = String(productTitle || '').toLowerCase();
    const type = String(productType || '').toLowerCase();
    const desc = String(productDescription || '').toLowerCase();

    const isRug = title.includes('rug') || type.includes('rug') || desc.includes('rug') ||
                  title.includes('carpet') || type.includes('carpet') || desc.includes('carpet') ||
                  title.includes('runner') || type.includes('runner') || desc.includes('runner');

    const isExempt = title.includes('pad') || type.includes('pad') || title.includes('underlay') || type.includes('underlay') ||
                    title.includes('cleaner') || type.includes('cleaner') || type.includes('furniture') || type.includes('accessory');

    if (!isRug || isExempt) {
      alert("Visualiser Currently works best with Rugs . Discovery is working on to support more home decor");
      throw new Error("Visualiser Currently works best with Rugs . Discovery is working on to support more home decor");
    }
  };
})(typeof window !== 'undefined' ? window : this);

// Get-session-token = Temporary-token-per-room-img-upload
const TEMP_TOKEN_KEY = 'Temporary-token-per-room-img-upload';

// --- In-Flight Request Tracker ---
// Stores active requests by cache key so duplicate callers await one promise.
const inFlightMaskRequests = new Map();

// Track only visualizer-owned async work without touching global browser APIs.
const pendingIDBWritePromises = new Set();
const pendingVisualizerFetchPromises = new Set();
const maskCacheWaitPromises = new Map();

function trackPendingPromise(set, promise) {
  set.add(promise);
  promise.finally(() => set.delete(promise));
  return promise;
}

function withOptionalTimeout(promise, timeoutMs, label) {
  if (typeof timeoutMs !== 'number' || timeoutMs <= 0) return promise;
  let timeoutId = null;
  const timeoutPromise = new Promise((_, reject) => {
    timeoutId = setTimeout(() => reject(new Error(`${label} timed out after ${timeoutMs}ms`)), timeoutMs);
  });
  return Promise.race([promise, timeoutPromise]).finally(() => {
    if (timeoutId) clearTimeout(timeoutId);
  });
}

async function waitForPromiseSetToDrain(set, timeoutMs, label) {
  const drainPromise = (async () => {
    while (set.size > 0) {
      await Promise.allSettled([...set]);
    }
  })();

  try {
    await withOptionalTimeout(drainPromise, timeoutMs, label);
  } catch (e) {
    console.warn(`${label} wait ended early:`, e);
  }
}

async function waitForPendingIDBWrites(timeoutMs) {
  await waitForPromiseSetToDrain(pendingIDBWritePromises, timeoutMs, 'IDB writes');
}

function visualizerFetch(...args) {
  if (typeof fetch !== 'function') {
    return Promise.reject(new Error('window.fetch is unavailable'));
  }
  return trackPendingPromise(pendingVisualizerFetchPromises, fetch(...args));
}

async function waitForPendingVisualizerFetches(timeoutMs) {
  await waitForPromiseSetToDrain(pendingVisualizerFetchPromises, timeoutMs, 'Visualizer fetches');
}

function extractUploadsPathForCache(url) {
  try {
    const value = String(url || '').trim();
    if (value.includes('/uploads/')) {
      const parts = value.split('/uploads/');
      const filename = parts[parts.length - 1].split('?')[0];
      return '/uploads/' + filename;
    }
    return value.split('?')[0];
  } catch {
    return String(url || '');
  }
}

async function recoverMaskDataLocally(maskCacheKey, roomUrl, points) {
  const normalizedPoints = normalizeInitialPoints(points);
  const pointsStr = JSON.stringify(normalizedPoints.map(([x, y]) => ({ x, y })));
  const uploadsPath = extractUploadsPathForCache(roomUrl);

  const exactCached = await idbGet(maskCacheKey);
  if (exactCached) return exactCached;

  const normalizedCacheKey = 'rv:mask:' + btoa(uploadsPath + pointsStr);
  if (normalizedCacheKey !== maskCacheKey) {
    const normalizedCached = await idbGet(normalizedCacheKey);
    if (normalizedCached) return normalizedCached;
  }

  if (Array.isArray(window.DEMO_ROOMS_DATA)) {
    const cleanRoomPath = uploadsPath.toLowerCase();
    for (const room of window.DEMO_ROOMS_DATA) {
      try {
        if (!room || !room.roomUrlForApi || !room.maskData) continue;
        const demoPath = extractUploadsPathForCache(room.roomUrlForApi).toLowerCase();
        if (cleanRoomPath === demoPath || (room.id && cleanRoomPath.includes(room.id)) || (demoPath && cleanRoomPath.includes(demoPath))) {
          console.log("✅ [DEMO MATCH] Recovered embedded maskData for:", room.id);
          return room.maskData;
        }
      } catch (_) { }
    }
  }

  return null;
}

/**
 * Safely resolves mask data by checking cache first, then awaiting any
 * in-flight request for the same key, and only then creating a new fetch.
 */
async function getOrFetchMaskData(cacheKey, networkFetchCallback, checkCacheCallback) {
  const cachedData = await checkCacheCallback(cacheKey);
  if (cachedData) {
    console.log(`[Tracker] Cache hit for ${cacheKey.substring(0, 30)}...`);
    return cachedData;
  }

  if (inFlightMaskRequests.has(cacheKey)) {
    console.log(`[Tracker] Request already in-flight. Waiting for ${cacheKey.substring(0, 30)}...`);
    return await inFlightMaskRequests.get(cacheKey);
  }

  console.log(`[Tracker] Cache miss. Initiating network request for ${cacheKey.substring(0, 30)}...`);

  const maskPromise = (async () => {
    try {
      const result = await networkFetchCallback();
      console.log(`[Tracker] Request successful for ${cacheKey.substring(0, 30)}...`);
      return result;
    } catch (error) {
      console.error(`[Tracker] Request failed for ${cacheKey.substring(0, 30)}...`, error);
      throw error;
    } finally {
      inFlightMaskRequests.delete(cacheKey);
    }
  })();

  inFlightMaskRequests.set(cacheKey, maskPromise);
  return maskPromise;
}

async function fetchAndCacheMaskData(maskCacheKey, roomUrl, points, forceToken = false) {
  //const safeRugUrl = "https://picsum.photos/id/0/60/50.jpg";
  const safeRugUrl = "https://placehold.co/60x50.jpg"
  const normalizedPoints = normalizeInitialPoints(points);

  const sessionPayload = {
    room_image_url: roomUrl,
    rug_image_url: safeRugUrl
  };

  // Old path: pass GPT-selected points if available.
  // New M2F/SAM1 path: omit initial_points and let backend calculate internally.
  if (normalizedPoints.length > 0) {
    sessionPayload.initial_points = normalizedPoints.map(([x, y]) => ({ x, y }));
  }

  // First check if mask data is available locally (embedded DEMO_ROOMS_DATA or IDB)
  const localMask = await recoverMaskDataLocally(maskCacheKey, roomUrl, points);
  if (localMask) {
    console.log("✅ Using local demo/cached mask for:", maskCacheKey.substring(0, 30));
    await idbSet(maskCacheKey, localMask);
    return localMask;
  }

  const sessionToken = await window.getSessionToken(forceToken);
  if (!sessionToken) {
    console.error("FATAL: initialize-session aborted. No session token was created by the upload UI.");
    throw new Error("Missing temporary session token.");
  }

  let targetApiBase = API_BASE_URL;
  if (roomUrl && String(roomUrl).includes('demo-room')) {
    targetApiBase = "https://api.productadvisorai.com";
  }

  console.log("SERVER: Requesting Mask & Data -> /initialize-session on", targetApiBase);
  let res = null;
  try {
    res = await visualizerFetch(`${targetApiBase}/initialize-session`, {
      method: "POST",
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${sessionToken}` },
      body: JSON.stringify(sessionPayload),
    });
  } catch (networkError) {
    const fallbackData = await recoverMaskDataLocally(maskCacheKey, roomUrl, points);
    if (fallbackData) {
      console.log("✅ Recovered mask data locally after network error for:", maskCacheKey.substring(0, 30));
      await idbSet(maskCacheKey, fallbackData);
      return fallbackData;
    }
    throw networkError;
  }

  if (!res.ok) {
    let errorDetail = `API Initialization Failed: ${res.status}`;
    try {
      const errJson = await res.json();
      if (errJson) {
        if (typeof errJson.detail === 'string') errorDetail = errJson.detail;
        else if (errJson.message) errorDetail = errJson.message;
        else if (errJson.error) errorDetail = errJson.error;
      }
    } catch (_) { }

    const fallbackData = await recoverMaskDataLocally(maskCacheKey, roomUrl, points);
    if (fallbackData) {
      console.log(`✅ Recovered mask data locally after /initialize-session ${res.status} for:`, maskCacheKey.substring(0, 30));
      await idbSet(maskCacheKey, fallbackData);
      return fallbackData;
    }

    if (
      String(errorDetail).includes('no positive points') ||
      String(errorDetail).includes('Mask2Former') ||
      String(errorDetail).includes('floor')
    ) {
      throw new Error("Valid floor not detected. Please upload a clear photo showing your room floor.");
    }

    throw new Error(errorDetail);
  }

  const data = await res.json();

  await idbSet(maskCacheKey, data);
  console.log("Mask, points, and intrinsics cached strictly to IDB forever.");
  return data;
}

async function waitForMaskCacheKey(maskCacheKey, timeoutMs) {
  if (!maskCacheKey) return null;

  const existing = await idbGet(maskCacheKey);
  if (existing) return existing;

  if (maskCacheWaitPromises.has(maskCacheKey)) {
    return maskCacheWaitPromises.get(maskCacheKey);
  }

  const waitPromise = new Promise((resolve) => {
    let timeoutId = null;
    let settled = false;

    const cleanup = () => {
      if (timeoutId) clearTimeout(timeoutId);
      window.removeEventListener('maskCached', onMaskCached);
    };

    const finish = async () => {
      if (settled) return;
      settled = true;
      cleanup();
      resolve(await idbGet(maskCacheKey));
    };

    const onMaskCached = (ev) => {
      if (ev?.detail?.key !== maskCacheKey) return;
      finish();
    };

    window.addEventListener('maskCached', onMaskCached);

    if (typeof timeoutMs === 'number' && timeoutMs > 0) {
      timeoutId = setTimeout(() => {
        console.warn('Timed out waiting for mask cache key:', maskCacheKey);
        finish();
      }, timeoutMs);
    }
  }).finally(() => {
    maskCacheWaitPromises.delete(maskCacheKey);
  });

  maskCacheWaitPromises.set(maskCacheKey, waitPromise);
  return waitPromise;
}

if (typeof window !== 'undefined') {
  window.visualizerFetch = visualizerFetch;
}

if (typeof window !== 'undefined') {
  window.addEventListener('visualizerClosed', async () => {
    try { await savePlacementForCurrentRoom(); } catch (e) { console.warn('save on visualizerClosed failed', e); }
  });
}

if (typeof document !== 'undefined') {
  document.addEventListener('visibilitychange', async () => {
    if (document.hidden) {
      try { await savePlacementForCurrentRoom(); } catch (e) { console.warn('save on visibilitychange failed', e); }
    }
  });
}

// --- PRELOAD ROOM MASK AFTER UPLOAD ---
window.preloadMaskData = async function (roomUrl, rugUrl, points, forceToken = false, isDemoImage = false) {
  const normalizedPoints = normalizeInitialPoints(points);

  if (!roomUrl) return null;

  // URL RECONSTRUCTION FIX: Reconstruct blob: URLs to valid server upload paths (https://.../uploads/...)
  // External backend servers cannot fetch browser-local blob: URLs directly during /initialize-session.
  let validRoomUrl = roomUrl;
  if (validRoomUrl && validRoomUrl.startsWith('blob:')) {
    try {
      const storedPath = await idbGet('analysis_filepath');
      if (storedPath) {
        validRoomUrl = (window.BACKEND_BASE_URL || "https://api.productadvisorai.com") + "/uploads/" + String(storedPath).replace(/^uploads\//, '').replace(/^\//, '');
        console.log('🔗 Reconstructed validRoomUrl from Blob in preloadMaskData:', validRoomUrl);
      }
    } catch (e) {
      console.warn("Failed to recover api path for blob in preloadMaskData", e);
    }
  }

  const pointsForKey = normalizedPoints.length
    ? normalizedPoints.map(([x, y]) => ({ x, y }))
    : [{ m2f: true }];

  console.log("🔍 preloadMaskData called with isDemoImage:", isDemoImage, "roomUrl:", validRoomUrl.substring(0, 50));

  function extractUploadPath(url) {
    try { return url.match(/\/uploads\/.+/)?.[0] || url; } catch { return url; }
  }

  const uploadPath = extractUploadPath(validRoomUrl);
  const maskCacheKey = 'rv:mask:' + btoa(uploadPath + JSON.stringify(pointsForKey));

  // Exact cache hits should always win, even if a real token exists.
  // Cached quiz / old-upload rooms must not reinitialize on the server.
  const cachedMaskData = await idbGet(maskCacheKey);
  if (cachedMaskData) {
    console.log("✅ Using cached mask for:", maskCacheKey.substring(0, 30));
    return cachedMaskData;
  }

  // A real server token means we should not skip initialize-session even if a stale demo flag leaks in.
  const sessionToken = accessToken || await idbGet(TEMP_TOKEN_KEY);
  const hasRealServerSession = !!(sessionToken && sessionToken !== 'demo-token');

  // If demo image is used, skip server call and use existing demo mask if available
  if (isDemoImage && !hasRealServerSession) {
    console.log("✅ Demo image detected - using embedded/local maskData");

    const localDemoMask = await recoverMaskDataLocally(
      maskCacheKey,
      validRoomUrl,
      normalizedPoints
    );

    if (localDemoMask) {
      await idbSet(maskCacheKey, localDemoMask);
      console.log("✅ Cached embedded demo mask for:", maskCacheKey.substring(0, 30));
      return localDemoMask;
    }

    console.warn("⚠️ Demo maskData could not be recovered locally");
    return null;
  }

  console.log("🔄 Real image - fetching from server via getOrFetchMaskData");
  // For real uploads (non-demo), fetch from server
  return await getOrFetchMaskData(
    maskCacheKey,
    async () => fetchAndCacheMaskData(maskCacheKey, validRoomUrl, normalizedPoints, forceToken),
    async (key) => await idbGet(key)
  );
};

// --- CONFIG ---
//const API_BASE_URL = "https://discovery-ai-labs--rug-visualizer-3-1-rugvisualizer-fastapi-app.modal.run"; // GPT + SAM2
const API_BASE_URL = "https://discovery-ai-labs--modular-rug-visualizer-3-1-sam1-rugvi-5994fe.modal.run"; // M2F + SAM1

const MAX_IMAGE_DIMENSION = 2048;
const RUG_BASE64_CACHE_PREFIX = 'rv:rugbase64:';
const IS_IOS = /iPhone|iPad|iPod/.test(navigator.userAgent);
const isMobile = window.innerWidth <= 768 || ('ontouchstart' in window);
const renderThrottle = isMobile ? 10 : 7;

// --- ELEMENTS ---
const roomImageInput = document.getElementById("room-image-input");
const rugImageInput = document.getElementById("rug-image-input");
const rugWidthInput = document.getElementById("rug-width-feet");
const rugWidthInchesInput = document.getElementById("rug-width-inches");
const rugHeightInput = document.getElementById("rug-height-feet");
const rugHeightInchesInput = document.getElementById("rug-height-inches");
const visualizeButton = document.getElementById("visualize-button");
const resultCanvas = document.getElementById("result-canvas");
const roomProcessingCanvas = document.getElementById("room-processing-canvas");
const rugProcessingCanvas = document.getElementById("rug-processing-canvas");
const messageArea = document.getElementById("message-area");
const pyodideStatus = document.getElementById("pyodide-status");
const rotationSlider = document.getElementById("rotation-slider");
const currentAngleDisplay = document.getElementById("current-angle");
let lastRejectShown = null;
// Rate-limit automatic placement resets to avoid flip-flopping
let lastAutoResetAt = 0;
const AUTO_RESET_COOLDOWN_MS = 2500;
let placementAutosaveTimer = null;
const PLACEMENT_AUTOSAVE_DELAY_MS = 600;

// --- SESSION HIGH-SCORE ANCHOR TRACKER ---
// Tracks the absolute best rug placement seen in the current room session.
// Uses a one-way ratchet: only updates when a strictly higher visibility ratio
// is achieved, so the anchor never degrades from furniture occlusion or edge drags.
const RugPlacementSession = {
  maxVisibleRatio: 0.0,
  bestCx: null,
  bestCy: null,
  // Hull centroid = geometric center of the *actually visible* rug pixels,
  // bridging gaps from occluding furniture via convex hull.
  bestHullCx: null,
  bestHullCy: null,

  /**
   * Call after every render. Fetches ratio + hull centroid from Python and
   * updates the high score if this position is strictly better.
   * @param {number} inputCx - interaction.cx used for this render
   * @param {number} inputCy - interaction.cy used for this render
   */
  evaluate(inputCx, inputCy) {
    if (typeof window.get_visible_ratio_js !== 'function') return;
    try {
      const getRatio = window.get_visible_ratio_js;
      const getHull = window.get_visible_hull_centroid_js;
      const ratio = getRatio ? (getRatio() || 0.0) : 0.0;
      if (ratio > this.maxVisibleRatio) {
        this.maxVisibleRatio = ratio;
        this.bestCx = inputCx;
        this.bestCy = inputCy;
        if (getHull) {
          const hull = getHull();
          if (hull) {
            const pts = Array.isArray(hull) ? hull : (hull.toJs?.() ?? hull);
            const hx = Number(pts[0]);
            const hy = Number(pts[1]);
            if (Number.isFinite(hx) && Number.isFinite(hy) && hx > 0 && hy > 0) {
              this.bestHullCx = hx;
              this.bestHullCy = hy;
            }
          }
        }
        console.log(`[HighScore] New max visibility: ${(ratio * 100).toFixed(1)}% at (${inputCx.toFixed(0)}, ${inputCy.toFixed(0)})`);
      }
    } catch (e) {
      console.warn('RugPlacementSession.evaluate failed:', e);
    }
  },

  /**
   * Returns the best placement coords seen this session, or null if none
   * with at least minRatio visibility has been recorded.
   * @param {number} [minRatio=0.05]
   */
  getBest(minRatio = 0.05) {
    if (this.maxVisibleRatio < minRatio || this.bestCx == null) return null;
    return { cx: this.bestCx, cy: this.bestCy, hullCx: this.bestHullCx, hullCy: this.bestHullCy };
  },

  reset() {
    this.maxVisibleRatio = 0.0;
    this.bestCx = null;
    this.bestCy = null;
    this.bestHullCx = null;
    this.bestHullCy = null;
  },
};
window.RugPlacementSession = RugPlacementSession;

const floorMaskCanvas = document.createElement("canvas");

const RUG_REJECT_MESSAGES = {
  ABOVE_HORIZON_UI: "Move the rug onto the floor",
  NEAR_HORIZON_RAY: "Too close to the wall",
  INVALID_DISTANCE: "Rug placement is too far away",
  BEHIND_CAMERA: "Invalid placement",
  CORNER_ABOVE_HORIZON: "Rug must sit fully on the floor",
  LOW_FLOOR_OVERLAP: "The rug slid off the floor, we’ll position it for you",
};

function markWarperReady() {
  try {
    window._visualizerWarperReady = true;
    if (Array.isArray(window._visualizerWarperReadyCallbacks)) {
      window._visualizerWarperReadyCallbacks.forEach((cb) => {
        try { cb(); } catch (_) { }
      });
    }
    window._visualizerWarperReadyCallbacks = [];

    // Caption handling: only show caption if loader isn't visible.
    const wrap = document.getElementById('visualizer-demo-wrap');
    const loadingGif = document.getElementById('visualizer-loading-gif');
    const msgArea = document.getElementById('message-area');
    const loaderVisible = loadingGif && loadingGif.isConnected && msgArea && window.getComputedStyle(msgArea).display !== 'none';

    if (wrap) {
      if (loaderVisible) {
        window._pendingVisualizerShowCaption = true;
      } else {
        wrap.classList.add('show-caption');
      }
    } else {
      window._pendingVisualizerShowCaption = true;
    }
  } catch (e) {
    console.warn('markWarperReady failed', e);
  }
}

if (typeof window !== 'undefined') {
  window._visualizerWarperReady = window._visualizerWarperReady || false;
  window._visualizerWarperReadyCallbacks = window._visualizerWarperReadyCallbacks || [];
  window.onWarperReady = markWarperReady;
}

// --- STATE ---

async function resetVisualizerState(preserveRoom = false) {
  console.log("🧹 Tearing down visualizer state... preserveRoom:", preserveRoom);

  clearTimeout(throttleTimer);
  throttleTimer = null;
  if (renderRafId !== null) {
    cancelAnimationFrame(renderRafId);
    renderRafId = null;
  }
  renderInFlight = false;
  renderPending = false;
  renderPendingHq = false;
  lastRenderKickAt = 0;
  clearTimeout(placementAutosaveTimer);
  placementAutosaveTimer = null;

  if (typeof window.cleanup_warper_strict === 'function') {
    try {
      window.cleanup_warper_strict();
    } catch (e) {
      console.warn("Could not clean up warper state:", e);
    }
  }

  if (!preserveRoom) {
    if (apiData.floorMaskBitmap) {
      try { apiData.floorMaskBitmap.close(); } catch (e) { }
    }

    apiData = {
      ready: false,
      floorMaskBitmap: null,
      initialPoint: null,
      initialPointsOriginal: null,
    };

    roomData = { ready: false, naturalWidth: 0, naturalHeight: 0, originalWidth: 0, originalHeight: 0, renderScale: 1.0 };
    renderFrameBuffer = null;
    renderFrameImageData = null;
  }

  rugData = { ready: false, naturalWidth: 0, naturalHeight: 0 };

  interaction.bound = false;
  placementLoadedForSession = false;
  placementValidationPending = false;
  originalInitialPointForPlacementFallback = null;
  lastProjectedCornersForPlacement = null;
  placementAnchorCorrectionPending = null;
  placementAnchorCorrectionAttempts = 0;
  RugPlacementSession.reset();
  lastKnownPlacementSnapshot = null;
  lastSavedPlacement = null;

  if (!preserveRoom) {
    try {
      window._visualizerWarperReady = false;
      window._visualizerWarperReadyCallbacks = [];
    } catch (_) { }
  }

  const clearCanvas = (canvas) => {
    if (!canvas) return;
    const ctx = canvas.getContext('2d');
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    canvas.width = 0; canvas.height = 0;
  };

  if (!preserveRoom) {
    clearCanvas(roomProcessingCanvas);
    clearCanvas(floorMaskCanvas);
    clearCanvas(resultCanvas);
    accessToken = null;
    sessionPromise = null;
  }
  clearCanvas(rugProcessingCanvas);
}

// --- INDEXED DB HELPER ---
const IDB_NAME = 'DiscoveryAIVisualizer';
const IDB_STORE = 'cacheStore';

function openDB() {
  return new Promise((resolve, reject) => {
    const req = indexedDB.open(IDB_NAME, 1);
    req.onupgradeneeded = (e) => e.target.result.createObjectStore(IDB_STORE);
    req.onsuccess = () => resolve(req.result);
    req.onerror = () => reject(req.error);
  });
}

async function idbGet(key) {
  try {
    const db = await openDB();
    return new Promise((resolve, reject) => {
      const req = db.transaction(IDB_STORE, 'readonly').objectStore(IDB_STORE).get(key);
      req.onsuccess = () => resolve(req.result);
      req.onerror = () => reject(req.error);
    });
  } catch (e) { console.warn("IDB Get Error", e); return null; }
}

async function idbSet(key, value) {
  const writePromise = (async () => {
    try {
      const db = await openDB();

      const tryPut = (v) => new Promise((resolve, reject) => {
        const req = db.transaction(IDB_STORE, 'readwrite').objectStore(IDB_STORE).put(v, key);
        req.onsuccess = () => resolve();
        req.onerror = () => reject(req.error || new Error('IDB put failed'));
      });

      try {
        await tryPut(value);
        if (typeof window !== 'undefined' && String(key || '').startsWith('rv:mask:')) {
          try { window.dispatchEvent(new CustomEvent('maskCached', { detail: { key } })); } catch (_) { }
        }
        return;
      } catch (err) {
        // If it's a File/Blob and the browser chokes on structured cloning, try cloning to a plain Blob
        try {
          const isBlob = (typeof Blob !== 'undefined' && value instanceof Blob) || (typeof File !== 'undefined' && value instanceof File);
          if (isBlob && typeof value.arrayBuffer === 'function') {
            const ab = await value.arrayBuffer();
            const clone = new Blob([ab], { type: (value && value.type) || 'application/octet-stream' });
            await tryPut(clone);
            if (typeof window !== 'undefined' && String(key || '').startsWith('rv:mask:')) {
              try { window.dispatchEvent(new CustomEvent('maskCached', { detail: { key } })); } catch (_) { }
            }
            return;
          }
        } catch (e) {
          console.warn('IDB Set blob fallback failed', e);
        }
        throw err;
      }
    } catch (e) {
      console.warn("IDB Set Error", e);
    }
  })();

  return trackPendingPromise(pendingIDBWritePromises, writePromise);
}

// -----------------------------
// Placement persistence helpers
// -----------------------------
let placementLoadedForSession = false;
let placementValidationPending = false;
let originalInitialPointForPlacementFallback = null;
let lastProjectedCornersForPlacement = null;
let placementAnchorCorrectionPending = null;
let placementAnchorCorrectionAttempts = 0;
// In-memory snapshot of the last valid placement before a drag and the
// most-recently saved placement (if any). These help us restore a sensible
// position when a user drags the rug out of the visible floor area.
let lastKnownPlacementSnapshot = null;
let lastSavedPlacement = null;

function schedulePlacementAutosave() {
  clearTimeout(placementAutosaveTimer);
  placementAutosaveTimer = setTimeout(async () => {
    try {
      await savePlacementForCurrentRoom();
    } catch (e) {
      console.warn('Autosave placement failed', e);
    }
  }, PLACEMENT_AUTOSAVE_DELAY_MS);
}

function clampNumber(v, min, max) {
  return Math.max(min, Math.min(max, v));
}

function toFiniteNumber(v) {
  const n = Number(v);
  return Number.isFinite(n) ? n : null;
}

function getNearEdgeAnchorFromCorners(corners) {
  if (!Array.isArray(corners) || corners.length < 4) return null;

  const parsed = corners
    .map((c) => {
      if (!Array.isArray(c) || c.length < 2) return null;
      const x = toFiniteNumber(c[0]);
      const y = toFiniteNumber(c[1]);
      return (x == null || y == null) ? null : [x, y];
    })
    .filter(Boolean);

  if (parsed.length < 4) return null;
  const sorted = parsed.slice().sort((a, b) => b[1] - a[1]);
  return [
    (sorted[0][0] + sorted[1][0]) / 2,
    (sorted[0][1] + sorted[1][1]) / 2,
  ];
}

function extractUploadPathForPlacement(url) {
  try {
    const match = String(url).match(/\/uploads\/.+/);
    return match ? match[0] : String(url || '');
  } catch {
    return String(url || '');
  }
}

function getPlacementStorageKeys() {
  if (!roomImageUrlForAPI) return null;

  const uploadPath = extractUploadPathForPlacement(roomImageUrlForAPI);
  const normalizedRugUrl = normalizeRugUrl(rugImageUrlForAPI || '');

  const roomKey = 'rv:placement:room:' + btoa(uploadPath);
  const roomAndRugKey = normalizedRugUrl
    ? 'rv:placement:room-rug:' + btoa(uploadPath + '|' + normalizedRugUrl)
    : null;

  // Backward compatibility for previously saved entries.
  const legacyRoomAndRugKey = 'rv:placement:' + btoa(uploadPath + '|' + (rugImageUrlForAPI || ''));

  return {
    roomKey,
    roomAndRugKey,
    legacyRoomAndRugKey,
  };
}

async function savePlacementForCurrentRoom() {
  try {
    const keys = getPlacementStorageKeys();
    if (!keys) return;

    const canvasW = roomData.naturalWidth || 0;
    const canvasH = roomData.naturalHeight || 0;
    const rugWFt = Math.max(0.5, Number(getRugWidthFeet() || 0));
    const rugHFt = Math.max(0.5, Number(getRugHeightFeet() || 0));

    const nearEdgeAnchor = getNearEdgeAnchorFromCorners(lastProjectedCornersForPlacement);

    const payload = {
      cx: interaction.cx,
      cy: interaction.cy,
      rot: interaction.rot,
      canvasW,
      canvasH,
      centerNormX: canvasW > 0 ? clampNumber(interaction.cx / canvasW, 0, 1) : null,
      centerNormY: canvasH > 0 ? clampNumber(interaction.cy / canvasH, 0, 1) : null,
      rugWFt,
      rugHFt,
      nearEdgeAnchorNormX: (nearEdgeAnchor && canvasW > 0) ? clampNumber(nearEdgeAnchor[0] / canvasW, 0, 1) : null,
      nearEdgeAnchorNormY: (nearEdgeAnchor && canvasH > 0) ? clampNumber(nearEdgeAnchor[1] / canvasH, 0, 1) : null,
      ts: Date.now()
    };

    // Save room-level placement so position persists across rug pages.
    await idbSet(keys.roomKey, payload);

    // Save room+rug placement for exact-match restore when available.
    if (keys.roomAndRugKey) {
      await idbSet(keys.roomAndRugKey, payload);
    }

    // Remember the last-saved placement in-memory so we can restore it
    // immediately if the user accidentally drags the rug out of the floor.
    try { lastSavedPlacement = payload; } catch (e) { /* ignore */ }

    console.log('✅ Saved New placement to IDB');
  } catch (e) {
    console.warn('Failed to save placement', e);
  }
}

async function loadPlacementForCurrentRoom() {
  try {
    const keys = getPlacementStorageKeys();
    if (!keys) return null;

    const candidates = [
      keys.roomKey,
      keys.roomAndRugKey,
      keys.legacyRoomAndRugKey,
    ].filter(Boolean);

    const loadedPlacements = [];
    for (const key of candidates) {
      const saved = await idbGet(key);
      if (saved) {
        const withMeta = (saved && typeof saved === 'object')
          ? { ...saved, _placementKey: key }
          : saved;
        loadedPlacements.push(withMeta);
      }
    }

    if (loadedPlacements.length === 0) return null;

    const getTs = (p) => {
      const ts = toFiniteNumber(p && p.ts);
      return ts != null ? ts : 0;
    };

    const getPriority = (p) => {
      const k = String(p && p._placementKey || '');
      if (k === String(keys.roomKey || '')) return 3;
      if (k === String(keys.roomAndRugKey || '')) return 2;
      return 1;
    };

    loadedPlacements.sort((a, b) => {
      const tsDelta = getTs(b) - getTs(a);
      if (tsDelta !== 0) return tsDelta;
      return getPriority(b) - getPriority(a);
    });

    const chosen = loadedPlacements[0] || null;
    if (chosen) {
      console.log('✅ Loaded placement from IDB (latest selected)', {
        chosenKey: chosen._placementKey,
        chosenTs: chosen.ts,
        candidates: loadedPlacements.map((p) => ({ key: p && p._placementKey, ts: p && p.ts })),
      });
      try { lastSavedPlacement = chosen; } catch (e) { /* ignore */ }
    }
    return chosen;

  } catch (e) {
    console.warn('Failed to load saved placement', e);
    return null;
  }
}

let accessToken = null;
let isRenderingHighRes = false;
let throttleTimer = null;
let renderRafId = null;
let renderInFlight = false;
let renderPending = false;
let renderPendingHq = false;
let lastRenderKickAt = 0;
let renderFrameBuffer = null;
let renderFrameImageData = null;
let roomData = { ready: false, naturalWidth: 0, naturalHeight: 0, originalWidth: 0, originalHeight: 0, renderScale: 1.0 };
let rugData = { ready: false, naturalWidth: 0, naturalHeight: 0 };
let apiData = {
  ready: false,
  floorMaskBitmap: null,
  initialPoint: null,
  initialPointsOriginal: null,
};
let roomImageUrlForAPI = null;
let rugImageUrlForAPI = null;
window.currentIsDemoImage = false;
window.currentRugUrlForApi = null;
let currentRoomFile = null;
let currentSessionId = null;
const PRELOADED_SESSION_PREFIX = "rv:init:";
let preloadedSessionData = null;
let preloadedSessionKey = null;

// Parsed rug dimensions (feet) from PDP Size strings like "6.7x9.10"
let currentRugDimensions = null;
let currentRugShape = null;

// Expose a small helper so other scripts can clear the active rug dimensions
// when the visualizer modal is closed.
try {
  window.clearCurrentRugDimensions = function () {
    try { currentRugDimensions = null; } catch (e) { /* ignore */ }
  };
} catch (e) { /* window not available? ignore */ }

function isRoundShape(shapeStr, sizeStr) {
  const combined = `${shapeStr || ''} ${sizeStr || ''}`.toLowerCase();
  return /\b(round|circle|circular)\b/.test(combined);
}

function stripRoundTokens(input) {
  return String(input || '').replace(/\b(round|circle|circular|diameter|dia)\b/ig, '').trim();
}

function parseSizeStringToFeetInchesParts(sizeStr, shapeHint = '') {
  if (!sizeStr) return null;

  let s = String(sizeStr).trim();
  s = s.replace(/\([^)]*\)/g, '').trim(); // Remove parenthesized tags like (runner)
  s = s.replace(/[\u2018\u2019\u201a\u201b]/g, "'");
  s = s.replace(/[\u201c\u201d\u201e\u201f]/g, '"');
  s = s.replace(/×|\u00D7/gi, 'x');
  s = s.replace(/\s*by\s*/ig, 'x');
  s = s.replace(/\s+/g, ' ').trim();

  try {
    if ((s[0] === '"' && s[s.length - 1] === '"') || (s[0] === "'" && s[s.length - 1] === "'")) {
      s = s.substring(1, s.length - 1).trim();
    }
  } catch (e) { }

  const roundHint = isRoundShape(shapeHint, s);
  const parts = s.split(/\s*(?:x|×|by)\s*/i);
  if (!parts || parts.length < 2) {
    const single = parseOnePart(stripRoundTokens(s));
    const hasValue = (single.ft > 0) || (single.inch > 0);
    if (!hasValue) return null;
    return {
      widthFeet: single.ft,
      widthInches: single.inch,
      heightFeet: single.ft,
      heightInches: single.inch,
      isRound: roundHint
    };
  }

  function normalizePair(ftVal, inchVal) {
    let ft = Number(ftVal) || 0;
    let inch = Number(inchVal) || 0;
    if (inch >= 12) {
      ft += Math.floor(inch / 12);
      inch = inch % 12;
    }
    return { ft: Math.max(0, ft), inch: Math.max(0, inch) };
  }

  function parseOnePart(part) {
    if (!part) return { ft: 0, inch: 0 };
    let str = String(part).toLowerCase().trim();
    str = str.replace(/^size\s*[:\-]?\s*/i, '').trim();

    // Feet with optional inches: 6' 7", 6'7, 6 ft 7 in, 6'
    let m = str.match(/^\s*(\d{1,2})\s*(?:'|ft|feet)\s*(?:(\d{1,2})\s*(?:"|in|inches)?\s*)?$/i);
    if (m) return normalizePair(parseInt(m[1], 10), parseInt(m[2] || '0', 10));

    // Inches only: 7", 7 in
    m = str.match(/^\s*(\d{1,2})\s*(?:"|in|inches)\s*$/i);
    if (m) return normalizePair(0, parseInt(m[1], 10));

    // Decimal style where dot means feet.inches (e.g. 6.8 -> 6'8")
    m = str.match(/^\s*(\d+)\.(\d{1,2})\s*$/);
    if (m) return normalizePair(parseInt(m[1], 10), parseInt(m[2], 10));

    // Two numbers separated by space (e.g. 6 7)
    m = str.match(/^\s*(\d{1,2})\s+(\d{1,2})\s*$/);
    if (m) return normalizePair(parseInt(m[1], 10), parseInt(m[2], 10));

    // Single number => feet
    m = str.match(/^\s*(\d+)\s*$/);
    if (m) return normalizePair(parseInt(m[1], 10), 0);

    return { ft: 0, inch: 0 };
  }

  const w = parseOnePart(parts[0]);
  const h = parseOnePart(parts[1]);
  if (roundHint) {
    const wIn = (w.ft * 12) + w.inch;
    const hIn = (h.ft * 12) + h.inch;
    const maxIn = Math.max(wIn, hIn);
    const ft = Math.floor(maxIn / 12);
    const inch = maxIn % 12;
    return {
      widthFeet: ft,
      widthInches: inch,
      heightFeet: ft,
      heightInches: inch,
      isRound: true
    };
  }
  return {
    widthFeet: w.ft,
    widthInches: w.inch,
    heightFeet: h.ft,
    heightInches: h.inch
  };
}

function applyPdpSizeAndShape(sizeStr, shapeStr) {
  try {
    currentRugShape = shapeStr || null;
    if (sizeStr) {
      currentRugDimensions = parseRugDimensions(sizeStr, shapeStr);
      const parts = parseSizeStringToFeetInchesParts(sizeStr, shapeStr) || {};
      const widthFeetInput = document.getElementById('rug-width-feet');
      const widthInchesInput = document.getElementById('rug-width-inches');
      const heightFeetInput = document.getElementById('rug-height-feet');
      const heightInchesInput = document.getElementById('rug-height-inches');

      function attachUserListener(el) {
        try {
          if (!el || el._userListenerAttached) return;
          el.addEventListener('input', () => {
            el.dataset.userEdited = '1';
            delete el.dataset.prefilled;
          });
          el._userListenerAttached = true;
        } catch (e) { }
      }

      [widthFeetInput, widthInchesInput, heightFeetInput, heightInchesInput].forEach(attachUserListener);

      if (widthFeetInput) {
        widthFeetInput.value = parts.widthFeet != null ? String(parts.widthFeet) : '';
        widthFeetInput.dataset.prefilled = '1';
        delete widthFeetInput.dataset.userEdited;
      }
      if (widthInchesInput) {
        widthInchesInput.value = parts.widthInches != null ? String(parts.widthInches) : '';
        widthInchesInput.dataset.prefilled = '1';
        delete widthInchesInput.dataset.userEdited;
      }
      if (heightFeetInput) {
        heightFeetInput.value = parts.heightFeet != null ? String(parts.heightFeet) : '';
        heightFeetInput.dataset.prefilled = '1';
        delete heightFeetInput.dataset.userEdited;
      }
      if (heightInchesInput) {
        heightInchesInput.value = parts.heightInches != null ? String(parts.heightInches) : '';
        heightInchesInput.dataset.prefilled = '1';
        delete heightInchesInput.dataset.userEdited;
      }
      console.log('✅ Applied PDP Source of Truth size and shape:', { sizeStr, shapeStr, currentRugDimensions });
    } else {
      currentRugDimensions = null;
    }
  } catch (e) {
    console.warn('Failed to apply PDP size/shape:', e);
    currentRugDimensions = null;
  }
}

function parseRugDimensions(sizeStr, shapeHint = '') {
  const parts = parseSizeStringToFeetInchesParts(sizeStr, shapeHint);
  if (!parts) return null;
  return {
    width: (Number(parts.widthFeet) || 0) + ((Number(parts.widthInches) || 0) / 12.0),
    height: (Number(parts.heightFeet) || 0) + ((Number(parts.heightInches) || 0) / 12.0)
  };
}

let interaction = {
  bound: false,
  isDragging: false,
  cx: 0,
  cy: 0,
  rot: 0,
  lastX: 0,
  lastY: 0,
};

let gestureState = {
  mode: null,
  initialAngle: null,
};

// --- UI STATUS HELPER ---
let originalButtonText = null;

const VISUALIZER_SIZE_TIP =
  'Tip: You can change the rug size and visualize again anytime.';

function setAppStatus(message, isDone = false, silent = false, isSmallChange = false) {
  if (visualizeButton) {
    if (!originalButtonText && visualizeButton.innerText) {
      originalButtonText = visualizeButton.innerText;
    }
    visualizeButton.innerText = message;
  }
  const statusText = message || 'Preparing your room view...';

  const overlay = (typeof document !== 'undefined') ? document.getElementById('visualizer-loading-overlay') : null;
  let glassToast = (typeof document !== 'undefined') ? document.getElementById('viz-glass-toast') : null;

  if (isDone || silent) {
    if (messageArea) {
      messageArea.style.display = 'none';
      messageArea.setAttribute('aria-hidden', 'true');
      messageArea.innerHTML = '';
    }
    if (overlay) {
      overlay.classList.add('hidden');
      overlay.setAttribute('aria-hidden', 'true');
    }
    if (glassToast) {
      glassToast.classList.remove('active');
    }
    const quizModal = (typeof document !== 'undefined') ? document.getElementById('digi-mo-quiz-modal') : null;
    if (quizModal) quizModal.style.display = 'none';
    return;
  }

  // Ensure background quiz loader modal is hidden so only ONE unified loader box is active
  if (typeof document !== 'undefined') {
    const quizModal = document.getElementById('digi-mo-quiz-modal');
    if (quizModal) quizModal.style.display = 'none';
  }

  // Handle small in-visualizer changes (size, variant) with floating Glass Toast Badge
  if (isSmallChange || (apiData && apiData.ready)) {
    if (messageArea) {
      messageArea.style.display = 'none';
    }
    if (!glassToast) {
      glassToast = document.createElement('div');
      glassToast.id = 'viz-glass-toast';
      glassToast.className = 'viz-glass-toast';
      const container = document.getElementById('see-in-room-modal') || document.body;
      container.appendChild(glassToast);
    }
    glassToast.innerHTML = `
      <svg class="viz-mini-spinner" viewBox="0 0 24 24">
        <circle class="viz-mini-bg" cx="12" cy="12" r="9" fill="none" stroke-width="2.5"/>
        <circle class="viz-mini-val" cx="12" cy="12" r="9" fill="none" stroke-width="2.5"/>
      </svg>
      <span class="viz-toast-label">${statusText}</span>
    `;
    glassToast.classList.add('active');
    return;
  }

  // Full-Screen Luxury Glassmorphic Card Loader (for initial upload)
  if (glassToast) glassToast.classList.remove('active');
  if (messageArea) {
    if (overlay) {
      overlay.classList.add('hidden');
      overlay.setAttribute('aria-hidden', 'true');
    }
    messageArea.classList.remove('visually-hidden');
    messageArea.style.display = 'flex';
    messageArea.setAttribute('aria-hidden', 'false');

    const existingCard = messageArea.querySelector('.viz-luxury-card');
    const existingTitle = messageArea.querySelector('.viz-luxury-title');

    if (existingCard && existingTitle) {
      existingTitle.textContent = statusText;
    } else {
      messageArea.innerHTML = `
        <div class="viz-luxury-card">
          <div class="viz-spinner-ring">
            <svg viewBox="0 0 50 50" class="viz-svg-spinner">
              <defs>
                <linearGradient id="vizSpinGrad" x1="0%" y1="0%" x2="100%" y2="100%">
                  <stop offset="0%" stop-color="#FFD700" />
                  <stop offset="50%" stop-color="#FFA500" />
                  <stop offset="100%" stop-color="#FF8C00" />
                </linearGradient>
              </defs>
              <circle class="viz-spinner-bg" cx="25" cy="25" r="20" fill="none" stroke-width="3.5" />
              <circle class="viz-spinner-val" cx="25" cy="25" r="20" fill="none" stroke-width="3.5" stroke="url(#vizSpinGrad)" />
            </svg>
          </div>
          <div class="viz-luxury-content">
            <p class="viz-luxury-title">${statusText}</p>
            <p class="viz-luxury-subtitle">REALISTIC LIGHTING & GEOMETRY</p>
          </div>
        </div>
      `;
    }
  } else if (overlay) {
    const label = overlay.querySelector('.loading-overlay__label');
    if (label) label.textContent = statusText;
    overlay.classList.remove('hidden');
    overlay.setAttribute('aria-hidden', 'false');
  }

  if (isDone && visualizeButton) {
    setTimeout(() => {
      visualizeButton.innerText = originalButtonText || "Visualize";
    }, 2500);
  }

  window.setAppStatus = setAppStatus;
}

window.isPyodideReady = true;
window.isWarperReady = true;

function markWarperReady() {
  window._visualizerWarperReady = true;
  window.isPyodideReady = true;
  window.isWarperReady = true;
  if (pyodideStatus) pyodideStatus.style.display = 'none';
  updateButtonState();
  console.log("✅ Visualizer Native Engine Ready");
}

window.initializePyodide = markWarperReady;
window.visualizerControllerReady = true;
window.waitForVisualizerControllerReady = function (timeoutMs = 8000) {
  if (window.visualizerControllerReady) return Promise.resolve(true);
  return new Promise((resolve, reject) => {
    let timeoutId = null;
    const onReady = () => {
      if (timeoutId) clearTimeout(timeoutId);
      window.removeEventListener('visualizerControllerReady', onReady);
      resolve(true);
    };
    window.addEventListener('visualizerControllerReady', onReady, { once: true });
    if (typeof timeoutMs === 'number' && timeoutMs > 0) {
      timeoutId = setTimeout(() => {
        window.removeEventListener('visualizerControllerReady', onReady);
        reject(new Error(`visualizerControllerReady timed out after ${timeoutMs}ms`));
      }, timeoutMs);
    }
  });
};
try { window.dispatchEvent(new Event('visualizerControllerReady')); } catch (_) { }

let sessionPromise = null;
async function getSessionToken(createIfMissing = false) {
  console.log('getSessionToken called with createIfMissing:', createIfMissing);
  if (accessToken && !createIfMissing) {
    console.log('Returning existing accessToken');
    return accessToken;
  }

  // If a request was fired by the '+' or 'Upload' button, wait for it!
  if (sessionPromise) {
    console.log('Returning pending sessionPromise');
    return sessionPromise;
  }

  // Skip IDB check if forcing new token creation
  if (!createIfMissing) {
    const idbToken = await idbGet(TEMP_TOKEN_KEY);
    if (idbToken) {
      console.log('Found token in IDB, setting accessToken');
      accessToken = idbToken;
      updateButtonState();
      return accessToken;
    }
  }

  // Visualizer is strictly banned from creating tokens, it will pass false here.
  if (!createIfMissing) {
    console.log('createIfMissing is false, returning null');
    return null;
  }

  console.log("🔴 SERVER: Requesting new session token → /get-session-token");
  sessionPromise = (async () => {
    try {
      const res = await visualizerFetch(`${API_BASE_URL}/get-session-token`, { method: "POST" });
      console.log('Fetch response status:', res.status);
      if (res.ok) {
        const data = await res.json();
        const token = data.access_token;
        if (token) {
          accessToken = token;
          await idbSet(TEMP_TOKEN_KEY, token);
          updateButtonState();
          console.log("✅ Session token received & stored in IDB");
          return token;
        }
      }
      throw new Error("Failed to get token");
    } catch (error) {
      console.warn('Network or server error in getSessionToken:', error);
      return null;
    } finally {
      sessionPromise = null;
    }
  })();

  return sessionPromise;
}

window.getSessionToken = getSessionToken;

// Bind a pending session token (created by +/upload click) to a specific room upload path.
// This ensures /initialize-session will only run when a room-specific mapping exists.
// Deprecate old mapping functions since we strictly use IDB now
window.bindPendingSessionToRoom = async function (roomKey) {
  console.log('⚪ Using IDB token directly.');
  return null;
};
window.getSessionForRoom = function (roomKey) { return null; };

function normalizeInitialPoints(points) {
  if (!Array.isArray(points)) return [];
  return points
    .map((p) => {
      if (Array.isArray(p) && p.length >= 2) return [Number(p[0]), Number(p[1])];
      if (p && typeof p === "object" && p.x != null && p.y != null) return [Number(p.x), Number(p.y)];
      return null;
    })
    .filter((p) => Array.isArray(p) && Number.isFinite(p[0]) && Number.isFinite(p[1]));
}

function normalizeRugUrl(url) {
  if (!url) return "";

  let raw = String(url).trim();
  if (!raw || raw === 'null' || raw === 'undefined') return "";

  // Normalize HTML-escaped entities
  raw = raw.replace(/&amp;/g, '&');

  // 1. Unwrap wsrv.nl proxy URLs to recover original full-res source URL
  if (raw.includes('wsrv.nl')) {
    try {
      const uMatch = raw.match(/wsrv\.nl\/\?.*?\burl=([^&]+)/i);
      if (uMatch && uMatch[1]) {
        raw = decodeURIComponent(uMatch[1]);
      }
    } catch (_) { }
  }

  // 2. Strip Discovery AI GCS /card/ and /thumb/ downsampled folders to fetch full resolution
  if (raw.includes('storage.googleapis.com') || raw.includes('discovery-ai-v3-public')) {
    if (/\.(webp)$/i.test(raw) && (raw.includes('/card/') || raw.includes('/thumb/'))) {
      raw = raw.replace(/\/card\/|\/thumb\//gi, '/').replace(/\.webp$/i, '.jpg');
    } else {
      raw = raw.replace(/\/card\//gi, '/').replace(/\/thumb\//gi, '/');
    }
  }

  // 3. Upgrade Shopify CDN image URLs to max resolution (2048x2048 / master)
  if (raw.includes('cdn.shopify.com') || raw.includes('myshopify.com')) {
    // Strip legacy filename size suffixes like _300x300.jpg, _small.png, _thumb.jpg
    raw = raw.replace(/_(?:pico|icon|thumb|small|compact|medium|large|granby|grande|100x100|200x200|300x300|400x400|500x500|600x600|800x800|1024x1024|\d+x\d*)(\.[a-z]{3,4}(?:\?.*)?)$/i, '$1');
    // Upgrade Modern Shopify OS 2.0 query parameters (width=300 -> width=2048)
    raw = raw.replace(/([?&])width=\d+/gi, '$1width=2048');
    raw = raw.replace(/([?&])height=\d+/gi, '');
  } else if (/\bw=\d+/i.test(raw)) {
    // Upgrade general image CDN width parameters (w=600 -> w=2048)
    raw = raw.replace(/([?&])w=\d+/gi, '$1w=2048').replace(/([?&])q=\d+/gi, '$1q=100');
  }

  if (/^(data:|blob:)/i.test(raw)) return raw;
  if (raw.startsWith("//")) return "https:" + raw;
  if (/^https?:\/\//i.test(raw)) return raw;

  // Shopify/cdn URLs can arrive without a protocol (e.g. cdn.shopify.com/...).
  if (/^[a-z0-9.-]+\.[a-z]{2,}(?:\/|$)/i.test(raw)) {
    return "https://" + raw;
  }

  // Root-relative URLs should be resolved against the active storefront origin.
  if (raw.startsWith('/')) {
    try {
      return new URL(raw, window.location.origin).toString();
    } catch (_) {
      return raw;
    }
  }

  // Last resort: resolve as a relative URL against current page.
  try {
    return new URL(raw, window.location.href).toString();
  } catch (_) {
    return raw;
  }
}


async function getRugImageCandidatesFromProductUrl(productUrl) {
  const normalizedProductUrl = normalizeRugUrl(productUrl || '');
  if (!normalizedProductUrl) return [];

  let productJsonUrl = null;
  try {
    const u = new URL(normalizedProductUrl, window.location.origin);
    if (typeof window !== 'undefined' && u.origin !== window.location.origin) {
      return [];
    }
    let path = String(u.pathname || '').replace(/\/+$/, '');
    if (!path || path === '/') return [];
    if (!path.endsWith('.js')) path = `${path}.js`;
    productJsonUrl = `${u.origin}${path}`;
  } catch (_) {
    return [];
  }

  try {
    const res = await visualizerFetch(productJsonUrl, { credentials: 'same-origin' });
    if (!res.ok) return [];
    const data = await res.json();

    const candidates = [];
    const addCandidate = (value) => {
      const normalized = normalizeRugUrl(value || '');
      if (!normalized) return;
      if (candidates.includes(normalized)) return;
      candidates.push(normalized);
    };

    addCandidate(data?.featured_image);
    if (Array.isArray(data?.images)) {
      data.images.forEach(addCandidate);
    }
    if (Array.isArray(data?.media)) {
      data.media.forEach((m) => {
        addCandidate(m?.src);
        addCandidate(m?.preview_image?.src);
        addCandidate(m?.image?.src);
      });
    }

    return candidates;
  } catch (e) {
    console.warn('Failed to resolve product image fallback candidates:', e);
    return [];
  }
}

// ✅ REMOVED: preloadVisualizerSession / preloadInitializeSession / buildVisualizationCacheKey
// These used a different cache prefix (rv:init:) causing duplicate initialize-session calls.
// All mask fetching now goes through preloadMaskData which uses rv:mask: consistently.

function sleep(ms) { return new Promise((r) => setTimeout(r, ms)); }
async function fileToBase64(file) {
  return new Promise((resolve, reject) => {
    const rd = new FileReader();
    rd.onload = () => resolve(rd.result);
    rd.onerror = reject;
    rd.readAsDataURL(file);
  });
}

async function urlToBase64(url, options = {}) {
  const productUrl = String(options?.productUrl || '').trim();
  const raw = String(url || '').trim();
  const normalized = normalizeRugUrl(raw);
  const cacheKey = normalized ? RUG_BASE64_CACHE_PREFIX + btoa(normalized) : '';

  if (cacheKey) {
    try {
      const cached = await idbGet(cacheKey);
      if (cached) return cached;
    } catch (e) {
      console.warn('Failed to read rug base64 cache:', e);
    }
  }

  const candidates = [];
  const addCandidate = (value) => {
    const v = String(value || '').trim();
    if (!v) return;
    if (candidates.includes(v)) return;
    candidates.push(v);
  };

  addCandidate(normalized);
  addCandidate(raw);

  // Discovery AI GCS variations (master .jpg vs .webp card/thumb)
  if (raw.includes('storage.googleapis.com') || raw.includes('discovery-ai-v3-public')) {
    addCandidate(raw.replace(/\/card\/|\/thumb\//gi, '/').replace(/\.webp$/i, '.jpg'));
    if (!raw.includes('/card/') && !raw.includes('/thumb/')) {
      addCandidate(raw.replace(/(\/[^\/]+)$/, '/card$1').replace(/\.(jpe?g|png)$/i, '.webp'));
    }
    addCandidate(raw.replace(/\/card\/|\/thumb\//gi, '/'));
  }

  // Extra fallback for protocol-less CDN host/path forms.
  if (/^cdn\.shopify\.com\//i.test(raw)) {
    addCandidate('https://' + raw);
  }

  let lastErr = null;

  const attemptCandidates = async (list) => {
    for (const candidate of list) {
      try {
        const res = await visualizerFetch(candidate);
        if (res.ok) {
          const blob = await res.blob();
          const base64 = await new Promise((resolve, reject) => {
            const rd = new FileReader();
            rd.onload = () => resolve(rd.result);
            rd.onerror = reject;
            rd.readAsDataURL(blob);
          });

          if (cacheKey) {
            try {
              await idbSet(cacheKey, base64);
            } catch (e) {
              console.warn('Failed to write rug base64 cache:', e);
            }
          }

          return base64;
        }
      } catch (e) {
        lastErr = e;
      }

      // Fallback: Load image via Image element to bypass CORS fetch restrictions on CDN images
      try {
        const base64 = await new Promise((resolve, reject) => {
          const img = new Image();
          img.crossOrigin = "anonymous";
          img.onload = () => {
            try {
              const cv = document.createElement("canvas");
              cv.width = img.naturalWidth || img.width;
              cv.height = img.naturalHeight || img.height;
              const ctx = cv.getContext("2d");
              ctx.drawImage(img, 0, 0);
              resolve(cv.toDataURL("image/png"));
            } catch (err) {
              reject(err);
            }
          };
          img.onerror = (err) => reject(err);
          img.src = candidate;
        });

        if (base64 && base64.length > 50) {
          if (cacheKey) {
            try {
              await idbSet(cacheKey, base64);
            } catch (e) {
              console.warn('Failed to write rug base64 cache:', e);
            }
          }
          return base64;
        }
      } catch (imgErr) {
        lastErr = imgErr;
      }
    }
    return null;
  };

  const primaryResult = await attemptCandidates(candidates);
  if (primaryResult) return primaryResult;

  // Fallback: resolve product images from same-origin product .js payload.
  if (productUrl) {
    const productCandidates = await getRugImageCandidatesFromProductUrl(productUrl);
    if (productCandidates.length > 0) {
      const fallbackResult = await attemptCandidates(productCandidates);
      if (fallbackResult) return fallbackResult;
    }
  }

  throw lastErr || new Error('Fetch failed: no valid rug image URL candidates');
}

function drawImageToCanvas(source, canvas, dataObj) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => {
      try {
        dataObj.originalWidth = img.naturalWidth;
        dataObj.originalHeight = img.naturalHeight;
        let w = img.naturalWidth;
        let h = img.naturalHeight;
        let s = 1.0;

        if (w > MAX_IMAGE_DIMENSION || h > MAX_IMAGE_DIMENSION) {
          s = MAX_IMAGE_DIMENSION / Math.max(w, h);
          w = Math.round(w * s);
          h = Math.round(h * s);
        }
        dataObj.naturalWidth = w;
        dataObj.naturalHeight = h;
        dataObj.renderScale = s;

        if (!canvas) throw new Error("Canvas element is null");
        canvas.width = w;
        canvas.height = h;
        const ctx = canvas.getContext("2d", { willReadFrequently: true });
        if (!ctx) throw new Error("Could not get 2D context");

        ctx.clearRect(0, 0, w, h);
        ctx.imageSmoothingEnabled = true;
        ctx.imageSmoothingQuality = "high";
        ctx.drawImage(img, 0, 0, w, h);
        resolve();
      } catch (err) {
        console.error("Error in drawImageToCanvas onload:", err);
        reject(err);
      }
    };
    img.onerror = () => reject(new Error("Image load failed"));
    img.crossOrigin = "anonymous";

    if (source instanceof Blob || source instanceof File) {
      const url = URL.createObjectURL(source);
      const origOnload = img.onload;
      img.onload = () => {
        try { if (origOnload) origOnload(); } finally { URL.revokeObjectURL(url); }
      };
      const origOnerror = img.onerror;
      img.onerror = () => {
        try { if (origOnerror) origOnerror(); } finally { URL.revokeObjectURL(url); }
      };
      img.src = url;
    } else {
      img.src = source;
    }
  });
}

function getRugWidthFeet() {
  if (currentRugDimensions && currentRugDimensions.width) return currentRugDimensions.width;

  const ft = parseFloat(rugWidthInput?.value || "0") || 0;
  const inch = parseFloat(rugWidthInchesInput?.value || "0") || 0;
  return ft + inch / 12.0;
}
function getRugHeightFeet() {
  if (currentRugDimensions && currentRugDimensions.height) return currentRugDimensions.height;

  const ft = parseFloat(rugHeightInput?.value || "0") || 0;
  const inch = parseFloat(rugHeightInchesInput?.value || "0") || 0;
  return ft + inch / 12.0;
}
function updateButtonState() {
  if (!visualizeButton) return;
  visualizeButton.disabled = !accessToken || isRenderingHighRes;
}
function getAngleBetweenTouches(touches) {
  const dx = touches[0].clientX - touches[1].clientX;
  const dy = touches[0].clientY - touches[1].clientY;
  return Math.atan2(dy, dx) * (180 / Math.PI);
}

// --- BRIDGE: Analyzer Success Handler ---
// Default to non-demo uploads so omitted args still follow real server flow.
window.handleAnalyzerSuccess = async function (apiResponse, uploadedFile, isDemoImage = false) {
  isDemoImage = isDemoImage === true;
  await idbSet('analysis_filepath', apiResponse.filepath);
  await idbSet('analysis_points', apiResponse.points);
  // Persist the actual uploaded File into the shared cache under a single key
  try {
    await idbSet('currentRoomImageBlob', uploadedFile);
    console.log('🟣 file saved to IDB as currentRoomImageBlob');
  } catch (e) {
    console.warn('Failed to save uploaded file to IDB', e);
  }

  // Write to RoomVisualizerDB so Room Manager grid shows this upload.
  // Only save real user uploads; demo images must not appear in user grid.
  if (!isDemoImage && uploadedFile instanceof File && window.roomImageCache && typeof window.roomImageCache.saveAnalyzedRoom === 'function') {
    try {
      await window.roomImageCache.saveAnalyzedRoom({
        file: uploadedFile,
        filepath: apiResponse.filepath,
        points: Array.isArray(apiResponse.points) ? apiResponse.points : [],
        facts: apiResponse.facts || null,
      });
      console.log('🟣 room saved to RoomVisualizerDB for Room Manager grid');
    } catch (e) {
      console.warn('Failed to save room to RoomVisualizerDB', e);
    }
  }

  //const roomUrlForApi = "https://api.productadvisorai.com/uploads/" + apiResponse.filepath.replace(/^uploads\//, '');
  const roomUrlForApi = (window.BACKEND_BASE_URL || "https://api.productadvisorai.com") + "/uploads/" + apiResponse.filepath.replace(/^uploads\//, '');

  const points = apiResponse.points;

  // Initialize a default resolved promise in case we skip preloading
  let maskPromise = Promise.resolve(null);

  // ✅ Always preload mask data to ensure IDB cache is hydrated, regardless of demo status
  // Normalize upload path for mapping (same formula used by preloadMaskData)
  function extractUploadPath(url) {
    try {
      const match = String(url).match(/\/uploads\/.+/);
      return match ? match[0] : url;
    } catch { return url; }
  }
  const preRugUrl = window.pendingSeeInRoom ? window.pendingSeeInRoom.rugUrl : "";
  const uploadPath = extractUploadPath(roomUrlForApi);

  // Bind any pending session (created by +/upload click) to this upload path.
  try {
    if (typeof window.bindPendingSessionToRoom === 'function') {
      // Fire-and-forget binding so we don't block the UI while session mapping completes
      try { window.bindPendingSessionToRoom(uploadPath).catch((e) => console.warn('bindPendingSessionToRoom failed:', e)); } catch (e) { console.warn('bindPendingSessionToRoom call failed:', e); }
    }
  } catch (e) {
    console.warn('Session bind before preload failed:', e);
  }

  maskPromise = window.preloadMaskData(roomUrlForApi, preRugUrl, points, false, isDemoImage)
    .catch(e => console.warn("Background mask prefetch failed", e));

  if (window.pendingSeeInRoom) {
    console.log("Resuming pending PDP request...");
    // This will wait for the mask if it's a real upload, or resolve instantly for demo images
    await maskPromise;

    const { rugUrl, sizeStr, productUrl, shapeStr } = window.pendingSeeInRoom;
    window.pendingSeeInRoom = null;

    // ✅ CRITICAL: Retrieve the cached maskData to avoid server calls for cached/demo rooms
    let cachedMaskData = null;
    try {
      function extractUploadPath(url) {
        try {
          const match = String(url).match(/\/uploads\/.+/);
          return match ? match[0] : url;
        } catch { return url; }
      }
      const normalizedPoints = normalizeInitialPoints(points);
      const pointsForKey = normalizedPoints.map(([x, y]) => ({ x, y }));
      const pointsStr = JSON.stringify(pointsForKey);
      const pathForCache = extractUploadPath(roomUrlForApi);
      const maskCacheKey = 'rv:mask:' + btoa(pathForCache + pointsStr);
      cachedMaskData = await idbGet(maskCacheKey);
      if (cachedMaskData) {
        console.log("✅ Retrieved cached maskData from IDB - will skip server call");
      }
    } catch (e) {
      console.warn("Failed to retrieve cached maskData:", e);
    }

    // Apply PDP Source of Truth size & shape to visualizer state and input elements
    applyPdpSizeAndShape(sizeStr, shapeStr);

    if (typeof showPreviewModal === 'function') showPreviewModal();

    const detail = {
      roomFile: uploadedFile,
      roomUrlForApi: roomUrlForApi,
      rugUrl: rugUrl,
      productUrl: productUrl || '',
      initialPoints: points,
      sizeStr: sizeStr,
      shapeStr: shapeStr || '',
      isDemoImage: isDemoImage,
      isNewUpload: !isDemoImage, // Pass the state down so the visualizer knows how to handle it
      maskData: cachedMaskData || undefined // ✅ Pass cached maskData to avoid server calls for cached/demo rooms
    };

    window.dispatchEvent(new CustomEvent('startAutomaticVisualization', { detail }));
  }
};

let lastAutomaticVisualizationTimestamp = 0;
let lastAutomaticVisualizationKey = '';

// ---------- EVENT HANDLING ----------
async function handleAutomaticVisualization(detail) {
  const { roomFile, roomUrlForApi, rugUrl, productUrl, initialPoints, sizeStr, shapeStr, maskData } = detail || {};
  const isDemoImage = detail && detail.isDemoImage === true;
  window.currentIsDemoImage = isDemoImage;
  const isNewUpload = detail && detail.isNewUpload === true;

  const vizKey = `${roomUrlForApi || ''}_${rugUrl || ''}_${sizeStr || ''}`;
  const now = Date.now();
  if (vizKey && vizKey === lastAutomaticVisualizationKey && (now - lastAutomaticVisualizationTimestamp < 800)) {
    console.warn("🚫 Suppressed duplicate handleAutomaticVisualization call within 800ms");
    return;
  }
  lastAutomaticVisualizationKey = vizKey;
  lastAutomaticVisualizationTimestamp = now;

  setAppStatus("Creating a realistic preview, gathering the details...");

  // PDP Size & Shape is the Source of Truth when launching visualization.
  applyPdpSizeAndShape(sizeStr, shapeStr);

  if (!roomFile || !rugUrl || !roomUrlForApi) {
    console.error("Pyodide Controller: Missing data for visualization.", detail);
    setAppStatus("Missing room or rug image. Please try again.", false);
    if (typeof visualizeButton !== "undefined" && visualizeButton) visualizeButton.disabled = false;
    return;
  }

  const safeInitialPoints = normalizeInitialPoints(initialPoints);

  const isReuse = !isNewUpload && roomData.ready && currentRoomFile === roomFile && apiData.floorMaskBitmap;

  await resetVisualizerState(isReuse);

  currentRoomFile = roomFile;
  currentSessionId = "session_" + Date.now();
  // apiData.initialPointsOriginal = normalizeInitialPoints(initialPoints);
  apiData.initialPointsOriginal = safeInitialPoints;
  roomImageUrlForAPI = roomUrlForApi;

  // URL RECONSTRUCTION FIX: Ensure blob: URLs are converted to valid server upload URLs before calling /initialize-session
  if (roomImageUrlForAPI && roomImageUrlForAPI.startsWith('blob:')) {
    try {
      const storedPath = await idbGet('analysis_filepath');
      if (storedPath) {
        roomImageUrlForAPI = (window.BACKEND_BASE_URL || "https://api.productadvisorai.com") + "/uploads/" + String(storedPath).replace(/^uploads\//, '').replace(/^\//, '');
        console.log('🔗 Reconstructed API URL from Blob:', roomImageUrlForAPI);
      }
    } catch (e) {
      console.warn("Failed to recover api path for blob", e);
    }
  }

  const fixedRugUrl = normalizeRugUrl(rugUrl);
  rugImageUrlForAPI = fixedRugUrl;

  function extractUploadPath(url) {
    try {
      const match = url.match(/\/uploads\/.+/);
      return match ? match[0] : url;
    } catch { return url; }
  }
  function normalizeUploadPathForKey(urlOrPath) {
    const path = extractUploadPath(String(urlOrPath || ''));
    return path.split('?')[0];
  }
  const normalizedPoints = normalizeInitialPoints(initialPoints);
  const pointsForKey = normalizedPoints.map(([x, y]) => ({ x, y }));
  const pointsStr = JSON.stringify(pointsForKey);

  let uploadPath = extractUploadPath(roomImageUrlForAPI);
  let maskCacheKey = 'rv:mask:' + btoa(uploadPath + pointsStr);
  const normalizedUploadPath = normalizeUploadPathForKey(uploadPath);

  setAppStatus("Creating a realistic preview, gathering the details...");

  // ✅ PRE-CACHE EMBEDDED maskData IF PROVIDED (e.g., from old-upload/cached quiz rooms)
  // This prevents unnecessary server calls for cached room data
  let cachedMaskData = null;
  if (maskData && typeof maskData === 'object' && maskData.floor_mask_base64) {
    console.log("✅ Using embedded maskData from old-upload/cached room - skipping server call");
    await idbSet(maskCacheKey, maskData);
    cachedMaskData = maskData;
  } else {
    cachedMaskData = await idbGet(maskCacheKey);

    // Query params can differ between sessions; retry with normalized uploads path.
    if (!cachedMaskData && normalizedUploadPath && normalizedUploadPath !== uploadPath) {
      const normalizedMaskCacheKey = 'rv:mask:' + btoa(normalizedUploadPath + pointsStr);
      cachedMaskData = await idbGet(normalizedMaskCacheKey);
      if (cachedMaskData) {
        maskCacheKey = normalizedMaskCacheKey;
        uploadPath = normalizedUploadPath;
      }
    }
  }

  if (!cachedMaskData) {
    setAppStatus("Getting everything ready for your room preview...", false);

    // If we have a real server token, never skip /initialize-session based on a leaked demo flag.
    const sessionToken = accessToken || await idbGet(TEMP_TOKEN_KEY);
    const hasRealServerSession = !!(sessionToken && sessionToken !== 'demo-token');
    const shouldSkipForDemo = isDemoImage && !hasRealServerSession;

    // Skip server call only for explicit demo images.
    // Real uploads/cached rooms should still call the server on cache miss.
    if (shouldSkipForDemo) {
      console.log("✅ Demo image detected in visualizer - skipping /initialize-session server call");
    } else {
      console.log("🔄 Fetching mask from server (cache miss)");
      try {
        cachedMaskData = await getOrFetchMaskData(
          maskCacheKey,
          async () => fetchAndCacheMaskData(maskCacheKey, roomImageUrlForAPI, normalizedPoints, false),
          async (key) => await idbGet(key)
        );
      } catch (e) {
        console.warn('Mask fetch via tracker failed:', e);
      }
    }
  }

  if (!cachedMaskData) {
    console.error('Mask data unavailable after waiting for cache key:', maskCacheKey);
    setAppStatus("Could not prepare room data. Please try again.", true);
    if (typeof visualizeButton !== "undefined" && visualizeButton) visualizeButton.disabled = false;
    return;
  }

  console.log("🟢 [CACHE HIT] Loaded room data directly from IDB.");
  setAppStatus("Almost Ready - Opening your room preview");

  try {
    const roomPromise = isReuse
      ? Promise.resolve()
      : drawImageToCanvas(roomFile, roomProcessingCanvas, roomData);

    const [_, __, ___, sessionData] = await Promise.all([
      Promise.resolve(),
      roomPromise,
      drawImageToCanvas(await urlToBase64(fixedRugUrl, { productUrl }), rugProcessingCanvas, rugData),
      Promise.resolve(cachedMaskData)
    ]);

    if (!sessionData || !sessionData.floor_mask_base64) {
      throw new Error("Mask data missing from cache");
    }

    roomData.ready = true;
    rugData.ready = true;

    if (!isReuse || !apiData.floorMaskBitmap) {
      setAppStatus("Placing the rug naturally in your space...");
      const maskBlob = await (await visualizerFetch(`data:image/png;base64,${sessionData.floor_mask_base64}`)).blob();
      apiData.floorMaskBitmap = await createImageBitmap(maskBlob);
    }

    if (resultCanvas) {
      resultCanvas.width = roomData.naturalWidth;
      resultCanvas.height = roomData.naturalHeight;
    }

    await runVisualization(sessionData);
  } catch (e) {
    console.error("Failed to initialize session/engine:", e);

    const errMsg = String(e && e.message ? e.message : e || '');
    const errMsgLower = errMsg.toLowerCase();

    if (
      errMsgLower.includes('valid floor not detected') ||
      errMsgLower.includes('no positive points') ||
      errMsgLower.includes('mask2former') ||
      errMsgLower.includes('floor')
    ) {
      setAppStatus("Valid floor not detected. Please upload a clear photo showing your room floor.", false);
      if (typeof window.showErrorToast === 'function') {
        window.showErrorToast("Valid floor not detected in this image. Please upload a clear photo showing your room floor.");
      }
    } else if (
      errMsgLower.includes('fetch failed') ||
      errMsgLower.includes('image load failed') ||
      errMsgLower.includes('valid rug image') ||
      errMsgLower.includes('404')
    ) {
      setAppStatus("Oops, something went wrong, try again shortly.", false);
      if (typeof window.showErrorToast === 'function') {
        window.showErrorToast("Oops, something went wrong. Please try again shortly.");
      }
    } else {
      setAppStatus(errMsg || "Error starting session", false);
      if (typeof window.showErrorToast === 'function') {
        window.showErrorToast(errMsg || "Error starting session. Please try another photo.");
      }
    }

    if (typeof visualizeButton !== "undefined" && visualizeButton) visualizeButton.disabled = false;
    if (typeof window.resetSeeInRoomButton === 'function') window.resetSeeInRoomButton();
    if (typeof window.hidePreviewModal === 'function') window.hidePreviewModal();
    return;
  }
}

window.addEventListener("startAutomaticVisualization", async (e) => {
  await handleAutomaticVisualization(e.detail);
});

document.addEventListener("startAutomaticVisualization", async (e) => {
  await handleAutomaticVisualization(e.detail);
});

// ---------- MAIN ----------
async function runVisualization(sessionData) {
  setAppStatus("Adjusting the rug size and angle for the best fit...");
  apiData.ready = false;

  try {
    setAppStatus("Just about ready... your room preview is on the way...");

    floorMaskCanvas.width = roomData.naturalWidth;
    floorMaskCanvas.height = roomData.naturalHeight;
    const maskCtx = floorMaskCanvas.getContext("2d", { willReadFrequently: true });
    maskCtx.clearRect(0, 0, floorMaskCanvas.width, floorMaskCanvas.height);
    maskCtx.drawImage(apiData.floorMaskBitmap, 0, 0, floorMaskCanvas.width, floorMaskCanvas.height);

    const maskData = maskCtx.getImageData(0, 0, floorMaskCanvas.width, floorMaskCanvas.height);

    const rugCtx = rugProcessingCanvas.getContext("2d", { willReadFrequently: true });
    const roomCtx = roomProcessingCanvas.getContext("2d", { willReadFrequently: true });

    const roomDataPy = roomCtx.getImageData(0, 0, roomData.naturalWidth, roomData.naturalHeight);
    const rugDataPy = rugCtx.getImageData(0, 0, rugData.naturalWidth, rugData.naturalHeight);

    const s = roomData.renderScale || 1.0;
    const defaultF = (roomData.originalWidth || 2000) * 0.65;
    let rawK = sessionData.intrinsics;

    if (Array.isArray(rawK) && Array.isArray(rawK[0])) {
      rawK = rawK.flat();
    }

    if (!rawK || rawK.length !== 9) {
      rawK = [
        defaultF, 0, (roomData.originalWidth || roomData.naturalWidth) / 2,
        0, defaultF, (roomData.originalHeight || roomData.naturalHeight) / 2,
        0, 0, 1
      ];
    }

    const rawP = sessionData.plane_coeffs || [0, 1, 0, -8];

    const scaledK = [
      rawK[0] * s, rawK[1] * s, rawK[2] * s,
      rawK[3] * s, rawK[4] * s, rawK[5] * s,
      rawK[6], rawK[7], rawK[8],
    ];

    let apiInitialPoint = [
      roomData.naturalWidth / 2,
      roomData.naturalHeight * 0.65
    ];

    if (Array.isArray(apiData.initialPointsOriginal) && apiData.initialPointsOriginal.length > 0) {
      const [ax, ay] = apiData.initialPointsOriginal[0];
      apiInitialPoint = [ax * s, ay * s];
    }

    // ── Init warper FIRST so trial renders and centroid work ──
    try {
      const initFn = window.initialize_warpers_strict || window.initialize_warpers_js;
      const ok = initFn(
        roomProcessingCanvas,
        rugProcessingCanvas,
        floorMaskCanvas,
        scaledK,
        rawP
      );
      if (!ok) throw new Error("Warper init returned false");
    } catch (e) {
      console.error("🔥 VISUALIZER ENGINE INIT EXCEPTION 🔥", e);
      throw e;
    }
    markWarperReady();

    // ── Now centroid is available (warper.floor_u8 exists) ──
    let floorCentroid = null;
    try {
      const centroidFn = window.get_floor_centroid_js;
      if (centroidFn) {
        const result = centroidFn();
        if (result) {
          const pts = Array.isArray(result) ? result : (result.toJs?.() ?? result);
          const cx = Number(pts[0]);
          const cy = Number(pts[1]);
          if (Number.isFinite(cx) && Number.isFinite(cy)
            && cx > 0 && cy > 0
            && cx < roomData.naturalWidth
            && cy < roomData.naturalHeight) {
            floorCentroid = [cx, cy];
            console.log(`Floor centroid: [${cx.toFixed(1)}, ${cy.toFixed(1)}]`);
          }
        }
      }
    } catch (e) {
      console.warn("Floor centroid unavailable", e);
    }

    // ── Build candidate list ──
    const placementCandidates = [];

    if (!placementLoadedForSession) {
      placementLoadedForSession = true;
      try {
        const saved = await loadPlacementForCurrentRoom();
        if (saved) {
          const savedW = toFiniteNumber(saved.canvasW) || roomData.naturalWidth || 1;
          const savedH = toFiniteNumber(saved.canvasH) || roomData.naturalHeight || 1;
          const scaleX = (roomData.naturalWidth || savedW) / savedW;
          const scaleY = (roomData.naturalHeight || savedH) / savedH;
          let scaledCx = null, scaledCy = null;
          const rawCx = toFiniteNumber(saved.cx);
          const rawCy = toFiniteNumber(saved.cy);
          const cnx = toFiniteNumber(saved.centerNormX);
          const cny = toFiniteNumber(saved.centerNormY);
          if (rawCx != null && rawCy != null) {
            scaledCx = rawCx * scaleX; scaledCy = rawCy * scaleY;
          } else if (cnx != null && cny != null) {
            scaledCx = cnx * (roomData.naturalWidth || 1);
            scaledCy = cny * (roomData.naturalHeight || 1);
          }
          if (scaledCx != null && scaledCy != null) {
            placementCandidates.push({
              label: 'saved',
              point: [
                clampNumber(scaledCx, 0, roomData.naturalWidth - 1),
                clampNumber(scaledCy, 0, roomData.naturalHeight - 1),
              ],
              rot: (typeof saved.rot === 'number') ? saved.rot : 0,
              savedMeta: saved,
            });
          }
        }
      } catch (e) {
        console.warn("Error loading saved placement", e);
      }
    }

    placementCandidates.push({ label: 'api', point: apiInitialPoint, rot: 0 });
    if (floorCentroid) {
      placementCandidates.push({ label: 'centroid', point: floorCentroid, rot: 0 });
    }

    // ── Trial render helper — warper now exists ──
    function trialRender(point, rot) {
      try {
        const w = Math.max(0.5, getRugWidthFeet() || 5);
        const h = Math.max(0.5, getRugHeightFeet() || 7);
        const renderCanvasFn = window.render_frame_canvas_js || window.render_frame_canvas;
        if (renderCanvasFn) {
          renderCanvasFn(point[0], point[1], w, h, rot, false);
        } else {
          const render3d = window.render_frame_3d_js || window.render_frame_3d;
          if (render3d) render3d(point[0], point[1], w, h, rot, false);
        }
        const getRatio = window.get_visible_ratio_js;
        return getRatio ? (getRatio() || 0.0) : 0.0;
      } catch (e) {
        console.warn("trialRender failed", e);
        return 0.0;
      }
    }

    // ── Pick best candidate ──
    const PLACEMENT_MIN_RATIO = 0.40;
    let chosenCandidate = null;
    const ratios = [];

    for (const candidate of placementCandidates) {
      const ratio = trialRender(candidate.point, candidate.rot);
      ratios.push(ratio);
      console.log(`Candidate [${candidate.label}] ratio: ${(ratio * 100).toFixed(1)}%`);
      if (ratio >= PLACEMENT_MIN_RATIO && !chosenCandidate) {
        chosenCandidate = candidate;
        // Don't break — log all for debugging, but first winner is used
      }
    }

    if (!chosenCandidate) {
      // Nothing hit 40% — use highest ratio
      let bestIdx = 0;
      for (let i = 1; i < ratios.length; i++) {
        if (ratios[i] > ratios[bestIdx]) bestIdx = i;
      }
      chosenCandidate = placementCandidates[bestIdx];
      console.warn(`No candidate hit 40% — using [${chosenCandidate.label}] at ${(ratios[bestIdx] * 100).toFixed(1)}%`);
    }

    // ── Apply chosen placement ──
    interaction.cx = chosenCandidate.point[0];
    interaction.cy = chosenCandidate.point[1];
    interaction.rot = chosenCandidate.rot;
    if (rotationSlider) rotationSlider.value = String(interaction.rot);
    apiData.initialPoint = chosenCandidate.point;

    // Carry over anchor correction metadata from saved placement
    if (chosenCandidate.label === 'saved' && chosenCandidate.savedMeta) {
      const saved = chosenCandidate.savedMeta;
      originalInitialPointForPlacementFallback = apiInitialPoint;
      placementValidationPending = false;
      const anchorNormX = toFiniteNumber(saved.nearEdgeAnchorNormX);
      const anchorNormY = toFiniteNumber(saved.nearEdgeAnchorNormY);
      const savedRugWFt = toFiniteNumber(saved.rugWFt);
      const savedRugHFt = toFiniteNumber(saved.rugHFt);
      const currentRugWFt = Math.max(0.5, Number(getRugWidthFeet() || 0));
      const currentRugHFt = Math.max(0.5, Number(getRugHeightFeet() || 0));
      const dimDiffW = (savedRugWFt > 0) ? Math.abs(currentRugWFt - savedRugWFt) / savedRugWFt : 0;
      const dimDiffH = (savedRugHFt > 0) ? Math.abs(currentRugHFt - savedRugHFt) / savedRugHFt : 0;
      const dimensionChanged = Math.max(dimDiffW, dimDiffH) > 0.08;
      const fromRoomOnlyKey = String(saved._placementKey || '').startsWith('rv:placement:room:');
      if (anchorNormX != null && anchorNormY != null && (fromRoomOnlyKey || dimensionChanged)) {
        placementAnchorCorrectionPending = {
          targetNormX: clampNumber(anchorNormX, 0, 1),
          targetNormY: clampNumber(anchorNormY, 0, 1),
        };
        placementAnchorCorrectionAttempts = 0;
      } else {
        placementAnchorCorrectionPending = null;
        placementAnchorCorrectionAttempts = 0;
      }
    }

    apiData.ready = true;
    startInteractionOnce();
    requestRender(true);
    setAppStatus("Ready to explore your fresh room looks ? ", true);
    try { window.dispatchEvent(new Event('visualizerFirstRenderDone')); } catch (_) { }

  } catch (e) {
    console.error("Init Error:", e);
    setAppStatus("Visualization failed", true);
  }
}

function startInteractionOnce() {
  if (interaction.bound) return;
  interaction.cx = apiData.initialPoint[0];
  interaction.cy = apiData.initialPoint[1];
  interaction.rot = rotationSlider ? parseFloat(rotationSlider.value || '0') : 0;
  interaction.bound = true;

  if (rotationSlider) {
    rotationSlider.addEventListener("input", () => {
      interaction.rot = parseFloat(rotationSlider.value || "0");
      if (currentAngleDisplay) currentAngleDisplay.innerText = `${interaction.rot}`;
      requestRender(false);
      schedulePlacementAutosave();
    });
    rotationSlider.addEventListener("change", async () => {
      requestRender(true);
      try { await savePlacementForCurrentRoom(); } catch (e) { console.warn('savePlacementForCurrentRoom failed', e); }
    });
  }

  [rugWidthInput, rugWidthInchesInput, rugHeightInput, rugHeightInchesInput].forEach((el) => {
    if (el) el.addEventListener("change", () => {
      currentRugDimensions = null;
      console.log('Pyodide controller: manual size input changed, clearing automatic dimensions');
      requestRender(true);
    });
  });

  resultCanvas.addEventListener("mousedown", (e) => {
    if (isRenderingHighRes) return;
    // Snapshot the placement before the user starts dragging so we can
    // revert to it if the drag takes the rug outside the visible floor.
    try { lastKnownPlacementSnapshot = { cx: interaction.cx, cy: interaction.cy, rot: interaction.rot }; } catch (e) { }
    interaction.isDragging = true;
    interaction.lastX = e.clientX;
    interaction.lastY = e.clientY;
    resultCanvas.style.cursor = "grabbing";
  });
  window.addEventListener("mousemove", (e) => {
    if (!interaction.isDragging || isRenderingHighRes) return;
    let dx = e.clientX - interaction.lastX;
    let dy = e.clientY - interaction.lastY;
    if (window.isCanvasAutoRotated && window.isCanvasAutoRotated()) {
      const tmp = dx;
      dx = dy;
      dy = -tmp;
    }
    interaction.cx += dx;
    interaction.cy += dy;
    interaction.lastX = e.clientX;
    interaction.lastY = e.clientY;
    requestRender(false);
    schedulePlacementAutosave();
  });
  window.addEventListener("mouseup", async () => {
    if (!interaction.isDragging) return;
    interaction.isDragging = false;
    resultCanvas.style.cursor = "grab";
    RugPlacementSession.evaluate(interaction.cx, interaction.cy);
    requestRender(true);
    try { await savePlacementForCurrentRoom(); } catch (e) { console.warn('savePlacementForCurrentRoom failed', e); }
  });

  resultCanvas.addEventListener("touchstart", (e) => {
    if (isRenderingHighRes) return;
    e.preventDefault();

    if (e.touches.length === 1) {
      gestureState.mode = "drag";
      // Snapshot the placement before the user starts dragging on touch.
      try { lastKnownPlacementSnapshot = { cx: interaction.cx, cy: interaction.cy, rot: interaction.rot }; } catch (err) { }
      interaction.isDragging = true;
      interaction.lastX = e.touches[0].clientX;
      interaction.lastY = e.touches[0].clientY;
    }
    else if (e.touches.length === 2) {
      gestureState.mode = "rotate";
      gestureState.initialAngle = getAngleBetweenTouches(e.touches);
      interaction.isDragging = false;
    }
  }, { passive: false });

  window.addEventListener("touchmove", (e) => {
    if (isRenderingHighRes || !gestureState.mode) return;
    e.preventDefault();

    if (gestureState.mode === "drag" && e.touches.length === 1) {
      const t = e.touches[0];
      let dx = t.clientX - interaction.lastX;
      let dy = t.clientY - interaction.lastY;
      if (window.isCanvasAutoRotated && window.isCanvasAutoRotated()) {
        const tmp = dx;
        dx = dy;
        dy = -tmp;
      }
      interaction.cx += dx;
      interaction.cy += dy;
      interaction.lastX = t.clientX;
      interaction.lastY = t.clientY;
      requestRender(false);
      schedulePlacementAutosave();
    }
    else if (gestureState.mode === "rotate" && e.touches.length === 2) {
      const currentAngle = getAngleBetweenTouches(e.touches);
      const delta = currentAngle - gestureState.initialAngle;

      interaction.rot += delta;

      if (interaction.rot > 180) interaction.rot -= 360;
      if (interaction.rot < -180) interaction.rot += 360;

      if (rotationSlider) rotationSlider.value = interaction.rot;
      if (currentAngleDisplay) {
        currentAngleDisplay.innerText = `${Math.round(interaction.rot)}`;
      }

      gestureState.initialAngle = currentAngle;
      requestRender(false);
      schedulePlacementAutosave();
    }
  }, { passive: false });

  window.addEventListener("touchend", async () => {
    if (!gestureState.mode) return;
    gestureState.mode = null;
    gestureState.initialAngle = null;
    interaction.isDragging = false;
    RugPlacementSession.evaluate(interaction.cx, interaction.cy);
    requestRender(true);
    try { await savePlacementForCurrentRoom(); } catch (e) { console.warn('savePlacementForCurrentRoom failed', e); }
  });
}

async function renderScene(hq = false) {
  if (!apiData.ready) return;
  if (hq && IS_IOS) hq = false;

  try {
    if (hq) {
      isRenderingHighRes = true;
      updateButtonState();
    }

    const w = Math.max(0.5, getRugWidthFeet() || 5);
    const h = Math.max(0.5, getRugHeightFeet() || 7);
    interaction.cx = Math.max(0, Math.min(roomData.naturalWidth - 1, interaction.cx));
    interaction.cy = Math.max(0, Math.min(roomData.naturalHeight - 1, interaction.cy));
    let rejectReason = null;
    let suppressRejectStatusThisFrame = false;

    try {
      const getReject = window.get_last_reject_reason_js || window.get_last_reject_reason;
      if (getReject) {
        rejectReason = getReject();
      }
    } catch (e) {
      console.warn("Reject reason fetch failed:", e);
    }

    if (resultCanvas.width !== roomData.naturalWidth) {
      resultCanvas.width = roomData.naturalWidth;
      resultCanvas.height = roomData.naturalHeight;
    }

    const ctx = resultCanvas.getContext("2d", { willReadFrequently: true });
    ctx.imageSmoothingEnabled = true;
    ctx.imageSmoothingQuality = "high";
    let didRenderFrame = false;

    try {
      const renderCanvasFn = window.render_frame_canvas_js || window.render_frame_canvas;
      if (renderCanvasFn) {
        const renderedCanvas = renderCanvasFn(
          interaction.cx,
          interaction.cy,
          w,
          h,
          interaction.rot,
          hq
        );
        if (renderedCanvas) {
          ctx.drawImage(renderedCanvas, 0, 0);
          didRenderFrame = true;
        }
      }
    } catch (e) {
      console.warn('Direct canvas render path failed, falling back:', e);
    }

    if (!didRenderFrame) {
      try {
        const renderIntoBuffer = window.render_frame_into_buffer_js || window.render_frame_into_buffer;
        if (renderIntoBuffer) {
          if (
            !renderFrameImageData ||
            renderFrameImageData.width !== roomData.naturalWidth ||
            renderFrameImageData.height !== roomData.naturalHeight
          ) {
            renderFrameBuffer = new Uint8ClampedArray(roomData.naturalWidth * roomData.naturalHeight * 4);
            renderFrameImageData = new ImageData(renderFrameBuffer, roomData.naturalWidth, roomData.naturalHeight);
          }

          const ok = renderIntoBuffer(
            interaction.cx,
            interaction.cy,
            w,
            h,
            interaction.rot,
            hq,
            renderFrameBuffer
          );

          if (ok) {
            ctx.putImageData(renderFrameImageData, 0, 0);
            didRenderFrame = true;
          }
        }
      } catch (e) {
        console.warn('Buffered render path failed, falling back:', e);
      }
    }

    if (!didRenderFrame) {
      const render3d = window.render_frame_3d_js || window.render_frame_3d;
      const img = render3d ? render3d(
        interaction.cx,
        interaction.cy,
        w,
        h,
        interaction.rot,
        hq
      ) : null;
      if (img) {
        ctx.putImageData(img, 0, 0);
        didRenderFrame = true;
      }
    }

    if (didRenderFrame) {
      RugPlacementSession.evaluate(interaction.cx, interaction.cy);

      // Try to fetch projected rug corners from the warper and publish an event
      try {
        const getCorners = window.get_projected_corners_js || window.get_projected_corners;
        if (getCorners) {
          try {
            const corners = getCorners(interaction.cx, interaction.cy, w, h, interaction.rot);
            // corners is returned as a JS array from Python via to_js (or null)
            if (corners) {
              document.dispatchEvent(new CustomEvent('rugProjectedCorners', { detail: { corners } }));
              lastProjectedCornersForPlacement = corners;

              const canvasW = resultCanvas.width || roomData.naturalWidth || 1;
              const canvasH = resultCanvas.height || roomData.naturalHeight || 1;

              // If we restored from room-level or changed rug dimensions, align the near-edge anchor.
              let correctionTriggered = false;
              if (placementAnchorCorrectionPending && placementAnchorCorrectionAttempts < 2) {
                const currentAnchor = getNearEdgeAnchorFromCorners(corners);
                if (currentAnchor) {
                  const targetAnchorX = placementAnchorCorrectionPending.targetNormX * canvasW;
                  const targetAnchorY = placementAnchorCorrectionPending.targetNormY * canvasH;
                  const dx = targetAnchorX - currentAnchor[0];
                  const dy = targetAnchorY - currentAnchor[1];
                  const dist = Math.hypot(dx, dy);

                  placementAnchorCorrectionAttempts += 1;

                  if (dist > 4) {
                    const gain = placementAnchorCorrectionAttempts === 1 ? 0.9 : 1.0;
                    interaction.cx = clampNumber(interaction.cx + dx * gain, 0, roomData.naturalWidth - 1);
                    interaction.cy = clampNumber(interaction.cy + dy * gain, 0, roomData.naturalHeight - 1);
                    correctionTriggered = true;
                    console.log('↔️ Applied anchor correction for rug-size normalization', {
                      attempt: placementAnchorCorrectionAttempts,
                      dist,
                      dx,
                      dy,
                    });
                    requestRender(true);
                    try { setAppStatus('', true); lastRejectShown = null; } catch (e) { /* ignore */ }
                  }

                  if (dist <= 4 || placementAnchorCorrectionAttempts >= 2) {
                    placementAnchorCorrectionPending = null;
                  }
                } else {
                  placementAnchorCorrectionPending = null;
                }
              }

              // If we just applied a saved placement, validate visibility.
              if (!correctionTriggered && placementValidationPending) {
                try {
                  const xs = corners.map(c => Number(c[0] || 0));
                  const ys = corners.map(c => Number(c[1] || 0));
                  const minX = Math.min(...xs);
                  const maxX = Math.max(...xs);
                  const minY = Math.min(...ys);
                  const maxY = Math.max(...ys);

                  const bboxW = Math.max(0, maxX - minX);
                  const bboxH = Math.max(0, maxY - minY);
                  const bboxArea = bboxW * bboxH;

                  const interLeft = Math.max(0, minX);
                  const interTop = Math.max(0, minY);
                  const interRight = Math.min(canvasW, maxX);
                  const interBottom = Math.min(canvasH, maxY);
                  const interW = Math.max(0, interRight - interLeft);
                  const interH = Math.max(0, interBottom - interTop);
                  const interArea = interW * interH;

                  const visibleRatio = (bboxArea > 0) ? (interArea / bboxArea) : 0;
                  console.log('Placement validation visibleRatio=', visibleRatio);

                  // If >50% hidden (visibleRatio <= 0.5) then revert to original initial point
                  if (visibleRatio <= 0.5) {
                    console.warn('Saved placement produced mostly-hidden rug — reverting to initial points.');
                    if (Array.isArray(originalInitialPointForPlacementFallback)) {
                      apiData.initialPoint = originalInitialPointForPlacementFallback.slice(0);
                      interaction.cx = apiData.initialPoint[0];
                      interaction.cy = apiData.initialPoint[1];
                    }
                    if (rotationSlider) {
                      rotationSlider.value = String(0);
                      interaction.rot = 0;
                    }
                    placementValidationPending = false;
                    placementAnchorCorrectionPending = null;
                    // Re-render with fallback placement
                    requestRender(true);
                    // Clear any visible "no space" / reject message since placement was corrected
                    try { setAppStatus('', true); lastRejectShown = null; } catch (e) { /* ignore */ }
                  } else {
                    // Accept saved placement
                    placementValidationPending = false;
                  }
                } catch (e) {
                  placementValidationPending = false;
                  console.warn('Placement validation error', e);
                }
              }
            }
          } catch (e) {
            // non-fatal; continue rendering
            console.warn('Failed to get projected corners:', e);
          }
        }
      } catch (e) {
        // ignore; pyodide may not expose function yet
      }

      // Position the mobile demo overlay over the rug's center (if visible)
      try {
        const wrap = document.getElementById('visualizer-demo-wrap');
        if (wrap && wrap.classList.contains('visible')) {
          const rect = resultCanvas.getBoundingClientRect();
          const cx = typeof interaction.cx === 'number' ? interaction.cx : (resultCanvas.width / 2);
          const cy = typeof interaction.cy === 'number' ? interaction.cy : (resultCanvas.height / 2);
          const canvasW = resultCanvas.width || rect.width;
          const canvasH = resultCanvas.height || rect.height;

          const fx = Math.max(0, Math.min(1, canvasW ? cx / canvasW : 0.5));
          const fy = Math.max(0, Math.min(1, canvasH ? cy / canvasH : 0.5));

          // Center the demo overlay in the viewport (middle of screen)
          const left = Math.round(window.innerWidth / 2);
          const top = Math.round(window.innerHeight / 2);
          wrap.style.position = 'fixed';
          wrap.style.left = `${left}px`;
          wrap.style.top = `${top}px`;
          wrap.style.bottom = 'auto';
          wrap.style.transform = 'translate(-50%, -50%)';
          wrap.style.pointerEvents = 'none';
        }
      } catch (e) {
        // non-fatal
      }

      // Auto-reset on LOW_FLOOR_OVERLAP — fires on any render, not only drags
      try {
        if (rejectReason === 'LOW_FLOOR_OVERLAP') {
          const now = Date.now();
          if (now - lastAutoResetAt > AUTO_RESET_COOLDOWN_MS) {
            lastAutoResetAt = now;
            let appliedFallback = false;

            // ① Session high score (best visible position this session)
            const sessionBest = RugPlacementSession.getBest(0.10);
            if (sessionBest) {
              const targetCx = sessionBest.hullCx ?? sessionBest.cx;
              const targetCy = sessionBest.hullCy ?? sessionBest.cy;
              interaction.cx = clampNumber(targetCx, 0, roomData.naturalWidth - 1);
              interaction.cy = clampNumber(targetCy, 0, roomData.naturalHeight - 1);
              appliedFallback = true;
              console.log(`[AutoReset] session high score ${(RugPlacementSession.maxVisibleRatio * 100).toFixed(1)}% → (${interaction.cx.toFixed(0)}, ${interaction.cy.toFixed(0)})`);
            }

            // ② IDB saved placement (cross-session memory)
            if (!appliedFallback && lastSavedPlacement) {
              try {
                const saved = lastSavedPlacement;
                const savedW = toFiniteNumber(saved.canvasW) || roomData.naturalWidth || 1;
                const savedH = toFiniteNumber(saved.canvasH) || roomData.naturalHeight || 1;
                const scaleX = (roomData.naturalWidth || savedW) / savedW;
                const scaleY = (roomData.naturalHeight || savedH) / savedH;
                const rawCx = toFiniteNumber(saved.cx);
                const rawCy = toFiniteNumber(saved.cy);
                const cnx = toFiniteNumber(saved.centerNormX);
                const cny = toFiniteNumber(saved.centerNormY);
                let scaledCx = null, scaledCy = null;
                if (rawCx != null && rawCy != null) { scaledCx = rawCx * scaleX; scaledCy = rawCy * scaleY; }
                else if (cnx != null && cny != null) { scaledCx = cnx * (roomData.naturalWidth || 1); scaledCy = cny * (roomData.naturalHeight || 1); }
                if (scaledCx != null) {
                  interaction.cx = clampNumber(scaledCx, 0, roomData.naturalWidth - 1);
                  interaction.cy = clampNumber(scaledCy, 0, roomData.naturalHeight - 1);
                  interaction.rot = (typeof saved.rot === 'number') ? saved.rot : interaction.rot;
                  if (rotationSlider) rotationSlider.value = String(interaction.rot);
                  appliedFallback = true;
                  console.log('[AutoReset] IDB saved placement');
                }
              } catch (e) { console.warn('IDB fallback failed', e); }
            }

            // ③ Drag-start snapshot
            if (!appliedFallback && lastKnownPlacementSnapshot) {
              interaction.cx = clampNumber(lastKnownPlacementSnapshot.cx || 0, 0, roomData.naturalWidth - 1);
              interaction.cy = clampNumber(lastKnownPlacementSnapshot.cy || 0, 0, roomData.naturalHeight - 1);
              interaction.rot = (typeof lastKnownPlacementSnapshot.rot === 'number') ? lastKnownPlacementSnapshot.rot : interaction.rot;
              if (rotationSlider) rotationSlider.value = String(interaction.rot);
              appliedFallback = true;
              console.log('[AutoReset] drag-start snapshot');
            }

            // ④ Original initial points (API floor detection result) — always available
            if (!appliedFallback) {
              if (Array.isArray(apiData.initialPointsOriginal) && apiData.initialPointsOriginal.length > 0) {
                const s = roomData.renderScale || 1.0;
                interaction.cx = apiData.initialPointsOriginal[0][0] * s;
                interaction.cy = apiData.initialPointsOriginal[0][1] * s;
              } else if (apiData.initialPoint) {
                interaction.cx = apiData.initialPoint[0];
                interaction.cy = apiData.initialPoint[1];
              }
              interaction.rot = 0;
              if (rotationSlider) rotationSlider.value = '0';
              console.log('[AutoReset] original initial points');
            }

            requestRender(true);
            suppressRejectStatusThisFrame = true;
            try { setAppStatus('', true); lastRejectShown = null; } catch (e) { }
          }
        }
      } catch (e) {
        console.warn('Auto-reset logic failed', e);
      }

      if (messageArea) {
        if (suppressRejectStatusThisFrame) {
          setAppStatus('', true);
          lastRejectShown = null;
        } else
          if (rejectReason && RUG_REJECT_MESSAGES[rejectReason]) {
            if (rejectReason !== lastRejectShown) {
              setAppStatus(RUG_REJECT_MESSAGES[rejectReason], false);
              lastRejectShown = rejectReason;
            }
          } else {
            setAppStatus('', true);
            lastRejectShown = null;
          }
      }
    }
  } catch (e) {
    console.error("Render Error:", e);
  } finally {
    isRenderingHighRes = false;
    updateButtonState();
  }
}

async function processQueuedRender() {
  renderRafId = null;
  if (!renderPending || renderInFlight) return;

  const hq = renderPendingHq;
  renderPending = false;
  renderPendingHq = false;
  renderInFlight = true;

  try {
    await renderScene(hq);
  } finally {
    renderInFlight = false;
    if (renderPending && renderRafId === null) {
      renderRafId = requestAnimationFrame(() => {
        void processQueuedRender();
      });
    }
  }
}

function requestRender(hq) {
  renderPending = true;
  if (hq) renderPendingHq = true;

  if (renderInFlight || renderRafId !== null) return;

  const now = (typeof performance !== 'undefined' && performance.now)
    ? performance.now()
    : Date.now();
  // During low-res preview (drag/rotate), zero out throttle for immediate 60FPS rAF response
  const effectiveThrottle = hq ? renderThrottle : 0;
  const wait = Math.max(0, effectiveThrottle - (now - lastRenderKickAt));

  if (throttleTimer !== null) {
    clearTimeout(throttleTimer);
    throttleTimer = null;
  }

  const kick = () => {
    lastRenderKickAt = (typeof performance !== 'undefined' && performance.now)
      ? performance.now()
      : Date.now();
    if (renderRafId !== null) return;
    renderRafId = requestAnimationFrame(() => {
      void processQueuedRender();
    });
  };

  if (wait > 0) {
    throttleTimer = setTimeout(() => {
      throttleTimer = null;
      kick();
    }, wait);
  } else {
    kick();
  }
}

async function logRoomImage(file, sessionId, category = "uploaded") {
  try {
    if (!file) return;

    const sid = sessionId || `session_${Date.now()}`;

    const uniqueName =
      `${Date.now()}_${Math.random().toString(36).slice(2)}_${file.name || "room.jpg"}`;

    try {
      const urlResponse = await visualizerFetch(`${API_BASE_URL}/get-upload-url`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          filename: uniqueName,
          content_type: file.type || "image/jpeg",
          session_id: sid,
          category
        }),
      });

      if (!urlResponse || !urlResponse.ok) return;

      const { upload_url } = await urlResponse.json();
      if (!upload_url) return;

      await visualizerFetch(upload_url, {
        method: "PUT",
        headers: { "Content-Type": file.type || "image/jpeg" },
        body: file,
      });
    } catch (netErr) {
      console.warn("logRoomImage network error ignored:", netErr);
    }

  } catch (e) {
    console.warn("logRoomImage failed (ignored):", e);
  }
}

async function handleSmartVariantChange(variantData) {
  if (!variantData) return false;
  const newRugUrl = variantData.image || window.currentRugUrlForApi;
  if (!newRugUrl && !variantData.size) return false;
  if (!apiData.ready || !apiData.floorMaskBitmap) return false;

  try {
    const normNew = typeof normalizeRugUrl === 'function' ? normalizeRugUrl(newRugUrl) : newRugUrl;
    const normCur = typeof normalizeRugUrl === 'function' ? normalizeRugUrl(window.currentRugUrlForApi || rugImageUrlForAPI || '') : (window.currentRugUrlForApi || rugImageUrlForAPI || '');
    const isNewImage = normNew && normNew !== normCur;

    if (isNewImage) {
      setAppStatus('Updating rug design...', false, false, true);
      const b64 = await urlToBase64(newRugUrl, {
        productUrl: variantData.productUrl || ''
      });
      if (b64) {
        await drawImageToCanvas(b64, rugProcessingCanvas, rugData);
        window.currentRugUrlForApi = normNew;
        rugImageUrlForAPI = normNew;

        const s = roomData.renderScale || 1.0;
        const defaultF = (roomData.originalWidth || 2000) * 0.65;
        const cx = (roomData.originalWidth || 2000) / 2.0;
        const cy = (roomData.originalHeight || 2000) / 2.0;
        const rawP = Array.isArray(apiData.pMatrix) && apiData.pMatrix.length === 12
          ? apiData.pMatrix
          : [defaultF, 0, cx, 0, 0, defaultF, cy, 0, 0, 0, 1, 0];
        const rawK = [rawP[0], rawP[1], rawP[2], rawP[4], rawP[5], rawP[6], rawP[8], rawP[9], rawP[10]];
        const scaledK = [rawK[0] * s, rawK[1] * s, rawK[2] * s, rawK[3] * s, rawK[4] * s, rawK[5] * s, rawK[6], rawK[7], rawK[8]];

        const initFn = window.initialize_warpers_strict || window.initialize_warpers_js;
        if (initFn) {
          initFn(roomProcessingCanvas, rugProcessingCanvas, floorMaskCanvas, scaledK, rawP);
        }
      }
    }

    if (variantData.size) {
      try {
        currentRugShape = variantData.shape || currentRugShape;
        currentRugDimensions = parseRugDimensions(variantData.size, variantData.shape);
      } catch (_) { }
    }

    requestRender(true);
    setAppStatus('', true);
    return true;
  } catch (e) {
    console.warn("Smart update rug failed, falling back to full reload", e);
    return false;
  }
}

document.addEventListener("visualizerVariantSelected", async (e) => {
  const variantData = e.detail;
  if (!currentRoomFile && !roomImageUrlForAPI) return;

  const isSmart = await handleSmartVariantChange(variantData);
  if (isSmart) {
    console.log("Successfully performed smart variant update without reload.");
    return;
  }

  const detail = {
    roomFile: currentRoomFile,
    roomUrlForApi: roomImageUrlForAPI,
    rugUrl: variantData.image || window.currentRugUrlForApi,
    initialPoints: apiData.initialPointsOriginal,
    sizeStr: variantData.size,
    shapeStr: variantData.shape || '',
    isDemoImage: window.currentIsDemoImage || false,
    isNewUpload: false,
    maskData: undefined
  };

  await handleAutomaticVisualization(detail);
});